// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:05:22.271Z
// Property: The Alden South Hills (ID: 6767906449166347)
// Collections: 34 amenities, 37 floorplans (live), 19 photos, 80 POIs, 1 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166347",
  "property_external_id": "4973437",
  "property_zillow_url": "https://www.zillow.com/apartments/pittsburgh-pa/the-alden/5XrtdM/",
  "property_apartments_url": "https://www.apartments.com/the-alden-south-hills-apartment-homes-pittsburgh-pa/9ws6nj7/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Alden+South+Hills+Apartments/data=!4m2!3m1!1s0x0:0xf9367f2504b41d1a?sa=X&ved=2ahUKEwiiy6S47biSAxUlke4BHTTQFkUQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "57765170234",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-alden-south-hills",
  "property_name": "The Alden South Hills",
  "property_website_url": "https://www.livethealdensouthhills.com/",
  "property_domain": "https://www.livethealdensouthhills.com/",
  "property_address": "5492 Youngridge Drive",
  "property_full_address": "5492 Youngridge Dr, Pittsburgh, PA 15236",
  "property_address_1": "5492 Youngridge Dr",
  "property_address_2": null,
  "property_address_city": "Pittsburgh",
  "property_address_state": "PA",
  "property_address_zip_full": "15236-3108",
  "property_address_zip": "15236",
  "property_address_country": "US",
  "property_address_county": "Allegheny County",
  "property_neighborhood_address": "Pleasant Hills",
  "property_address_latitude": "40.3385875",
  "property_address_longitude": "-79.97883329999999",
  "property_email": "thealden@aionmanagement.com",
  "property_phone": "(412) 655-9222",
  "property_call_tracking_phone": "878-283-2801",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At The Alden South Hills in Pittsburgh, PA, diverse floor plans span from cozy studios to spacious three-bedroom apartments. Enjoy a wealth of amenities, including a fitness center, swimming pool, pet-friendly dog park, and an inviting clubhouse. Your ideal living experience awaits—check availability or schedule a tour today!",
  "property_long_description": "**Discover Your Dream Apartment at The Alden South Hills in Pittsburgh, PA!**\n\nWelcome to The Alden South Hills, the ultimate destination for modern living in the heart of Pittsburgh! Our vibrant apartment community offers an array of thoughtfully designed floor plans, from cozy studios to spacious three-bedroom apartments, ensuring there’s a perfect fit for everyone. With our seamless online resident portal and flexible rent payment options, your comfort and convenience are our priorities.\n\nStep outside your door and dive into our extensive array of amenities designed to elevate your lifestyle. Unwind at our relaxing outdoor lounge or take a refreshing dip in the sparkling swimming pool. For fitness enthusiasts, our state-of-the-art fitness center and convenient basketball court will keep you active and engaged. Families will love the playground, picnic area, and dog park, creating an inviting space for residents of all ages to enjoy.\n\nAt The Alden South Hills, we prioritize your peace of mind with 24-hour emergency maintenance, on-site management, and secure parking. Our pet-friendly community ensures that your furry companions feel at home, too! Plus, with short-term leases available and our thriving resident activities, you’ll feel right at home from day one.\n\nExperience luxurious living in a mid-rise setting with upgraded interiors, featuring air conditioning, wall-to-wall carpeting, and modern appliances. With the convenience of public transportation just a walk away, daily commuting couldn’t be easier!\n\nDon't miss your opportunity to be part of our vibrant community. **Find your new home today—browse our availability or schedule a tour to visit The Alden South Hills!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-02e9-7038-9025-4554f41c4043.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and a granite countertop.",
    "public_id": "019fce0b-02e9-7038-9025-4554f41c4043",
    "storage_key": "property/6767906449166347/019fce0b-02e9-7038-9025-4554f41c4043.webp",
    "width": 1536,
    "height": 1025
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "1050",
  "property_year_built": "1950",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.85714285714285",
  "property_admin_fee": "50",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "All animals must be housebroken; no breeding allowed. Restricted dog breeds include German Shepherds, Akitas, Chow Terriers or mixes, American Bulldogs, Bull Staff/Staffordshire Terriers, Dobermans, Rottweilers, Wolf‑dog hybrids, Pit‑bull terriers, Presa Canario, or any Canary dog variety (50% or more by breed, verified by veterinary report). Breed and weight restrictions apply.",
  "property_pet_policy_description": "We allow dogs, cats, and service animals. All animals must be housebroken; no breeding allowed. Restricted dog breeds include German Shepherds, Akitas, Chow Terriers or mixes, American Bulldogs, Bull Staff/Staffordshire Terriers, Dobermans, Rottweilers, Wolf‑dog hybrids, Pit‑bull terriers, Presa Canario, or any Canary dog variety (50% or more by breed, verified by veterinary report). A one‑time non‑refundable pet fee of $350 is due at move‑in. Monthly pet rent is $50 for the first pet and an additional $25 for a second pet. Maximum of two pets per unit. Breed and weight restrictions apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://thealdenpittsburgh.loftliving.com/login",
  "property_apply_now_url": "https://www.livethealdensouthhills.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-8b95-7698-9d73-51d4e929b40e.webp",
  "property_primary_logo_media": {
    "alt_text": "The Alden South Hills logo",
    "public_id": "019d026d-8b95-7698-9d73-51d4e929b40e",
    "storage_key": "property/6767906449166347/019d026d-8b95-7698-9d73-51d4e929b40e.webp",
    "width": 640,
    "height": 158
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-8b95-7698-9d73-51d4e929b40e.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Alden South Hills logo",
    "public_id": "019d026d-8b95-7698-9d73-51d4e929b40e",
    "storage_key": "property/6767906449166347/019d026d-8b95-7698-9d73-51d4e929b40e.webp",
    "width": 640,
    "height": 158
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-98b9-7289-b864-3496aba15cfe.webp",
  "property_icon_media": {
    "alt_text": "The Alden South Hills logo",
    "public_id": "019d026d-98b9-7289-b864-3496aba15cfe",
    "storage_key": "property/6767906449166347/019d026d-98b9-7289-b864-3496aba15cfe.webp",
    "width": 300,
    "height": 300
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-98b9-7289-b864-3496aba15cfe.webp",
  "property_fav_icon_media": {
    "alt_text": "The Alden South Hills logo",
    "public_id": "019d026d-98b9-7289-b864-3496aba15cfe",
    "storage_key": "property/6767906449166347/019d026d-98b9-7289-b864-3496aba15cfe.webp",
    "width": 300,
    "height": 300
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-a5a3-70fb-988c-26e4360ea7e3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Alden South Hills logo",
    "public_id": "019d026d-a5a3-70fb-988c-26e4360ea7e3",
    "storage_key": "property/6767906449166347/019d026d-a5a3-70fb-988c-26e4360ea7e3.webp",
    "width": 640,
    "height": 158
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-b4fe-7189-94e3-4dc7e953ec36.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Alden South Hills logo.",
    "public_id": "019d026d-b4fe-7189-94e3-4dc7e953ec36",
    "storage_key": "property/6767906449166347/019d026d-b4fe-7189-94e3-4dc7e953ec36.webp",
    "width": 640,
    "height": 158
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "416 - 767",
  "property_sqft_min": "416",
  "property_sqft_max": "767",
  "property_price_range": "816 - 1206",
  "property_price_min": "816",
  "property_price_max": "1206",
  "property_available_units": 33,
  "property_facebook_url": "https://www.facebook.com/TheAldenSouthHills/",
  "property_instagram_url": "https://www.instagram.com/thealdensouthhills",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJk5LI9kH6NIgRGh20BCV_Nvk",
  "property_youtube_url": "https://www.youtube.com/watch?t=35&v=MmYhiWYTqD0",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Bethel+Park%2C+PA+15102",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Alden South Hills",
  "property_home_romance_title": "Embrace Your New Home, Create Lasting Memories Together  ",
  "property_home_amenities_blurb": "Welcome to The Alden South Hills, where comfort meets convenience in the heart of Pittsburgh. Choose from versatile floor plans, including studios and spacious three-bedroom options. Enjoy an array of amenities, from our inviting swimming pool to the vibrant resident lounge, all tailored for your modern lifestyle. Your new home awaits!",
  "property_home_floorplans_blurb": "Welcome to The Alden South Hills in Pittsburgh, PA, where contemporary living meets comfort. Choose from our diverse selection of floor plans, including stylish studios and spacious three-bedroom layouts. Elevate your lifestyle—browse our available apartment homes and uncover the perfect fit for your needs today!",
  "property_home_gallery_blurb": "At The Alden South Hills in vibrant Pittsburgh, PA, we offer a variety of stylish floor plans, from cozy studios to spacious townhomes. Enjoy our exceptional amenities, including a basketball court, fitness center, and dog park. Picture yourself living here, where comfort meets convenience in a pet-friendly community!",
  "property_home_neighborhood_blurb": "Welcome to The Alden South Hills, where vibrant living meets a rich tapestry of nearby attractions! From the serene landscapes of South Park to educational excellence at local schools, enjoy easy access to family-friendly parks, cultural hubs like the Pittsburgh Zoo, and convenient shopping. Your ideal home awaits!",
  "property_home_reviews_blurb": "Experience the comfort of The Alden South Hills, where exceptional service meets a vibrant community. Our residents rave about the \"friendly and helpful\" staff and the \"prompt and efficient\" maintenance. With a prime location in Pittsburgh, you'll find convenience at your doorstep. Come see why our community feels like home!",
  "property_neighborhood_blurb": "At The Alden South Hills, a vibrant community in Pittsburgh, the perfect blend of leisure and convenience awaits. Just steps away, immerse yourself in nature at South Park, unwind at local parks, or catch a show at Century Square Luxury Cinemas. Experience a lifestyle rich in culture and comfort!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to The Alden South Hills in Pittsburgh, where modern living meets vibrant community life. From spacious floor plans—including studios and townhomes—to fantastic amenities like a basketball court, fitness center, and pet-friendly spaces, your ideal lifestyle awaits. Dive into comfort and convenience today!",
  "property_applynow_blurb": "At The Alden South Hills in Pittsburgh, PA, finding the perfect apartment is effortless. Choose from studio to three-bedroom layouts, and enjoy amenities like a serene dog park, vibrant clubhouse, and a refreshing swimming pool. Lease online today and elevate your lifestyle in our welcoming community!",
  "property_contactus_blurb": "At The Alden South Hills in Pittsburgh, PA, our diverse floor plans cater to your lifestyle—ranging from cozy studios to spacious three-bedroom apartments. Each home is designed for comfort and convenience. Have questions? Contact our leasing team today to find the perfect fit for you!",
  "property_faqs_blurb": "At The Alden South Hills in Pittsburgh, PA, we offer diverse floor plans, from cozy studios to spacious three-bedroom apartments, designed to fit your lifestyle. Have questions about our community? Browse our FAQs page for insights and details tailored to your needs! Your new home awaits!",
  "property_floorplans_blurb": "At The Alden South Hills in vibrant Pittsburgh, PA, each thoughtfully designed floor plan—ranging from cozy studios to spacious three-bedroom apartments—invites you to envision your ideal lifestyle. Browse our available options and find the perfect layout that suits your needs and aspirations. Your dream apartment awaits!",
  "property_gallery_blurb": "At The Alden South Hills in Pittsburgh, PA, vibrant living converges with modern comforts. From cozy studios to spacious townhomes, our community offers something for everyone. Enjoy an outdoor lounge, fitness center, and pet-friendly amenities. Picture yourself relaxing by the pool or engaging in resident activities—your dream lifestyle awaits!",
  "property_interactivemap_blurb": "Welcome to The Alden South Hills, your gateway to comfortable living in Pittsburgh, PA. With diverse floor plans—from cozy studios to spacious three-bedroom townhomes—plus amenities like a sparkling swimming pool, a dog park, and a vibrant resident lounge, your perfect home awaits. Navigate your future with our interactive community map!",
  "property_pets_blurb": "At The Alden South Hills in Pittsburgh, we invite you and your furry companions to enjoy a vibrant lifestyle. With spacious apartments and scenic surroundings, your pets will feel right at home. Bring your beloved dogs or cats, and experience a community that understands the joy of pet ownership—ponders and restrictions apply.",
  "property_referafriend_blurb": "At The Alden South Hills in Pittsburgh, PA, your ideal home awaits, from cozy studios to spacious three-bedroom apartments. Share the joy of your vibrant community—refer a friend today and strengthen your neighborhood bonds. After all, great friends make the best neighbors! ",
  "property_residentaccess_blurb": "At The Alden South Hills in Pittsburgh, PA, elevate your living experience with versatile floor plans ranging from cozy studios to spacious three-bedroom apartments. Seamlessly manage your home life—log in to our resident portal for effortless rent payments and maintenance requests, ensuring your comfort comes first.",
  "property_reviews_blurb": "At The Alden South Hills, residents revel in a friendly atmosphere and prompt maintenance, with one satisfied tenant describing the community as “comfortable and accessible to many businesses in the area.” Join our welcoming neighborhood in Pittsburgh, PA, and experience exceptional living firsthand. Your happily ever after awaits!",
  "property_created_at": "1757011652778",
  "property_scheduletour_blurb": "At The Alden South Hills, your perfect home awaits in Pittsburgh, PA! Whether you’re drawn to our cozy studios or spacious three-bedroom apartments, each floor plan is designed with comfort and style in mind. Schedule a tour today and hear firsthand from our residents about their vibrant community life!",
  "property_thankyou_blurb": "Thank you for reaching out! At The Alden South Hills in Pittsburgh, PA, we offer an array of thoughtfully designed floor plans—studios to three bedrooms—tailored to suit your lifestyle. A member of our team will be in touch soon to help you find your perfect home.",
  "property_virtualtours_blurb": "At The Alden South Hills in Pittsburgh, PA, our thoughtfully designed apartments cater to every lifestyle. Whether you're seeking a cozy studio or an expansive three-bedroom layout, our floor plans are tailored for comfort and convenience. Immerse yourself in our vibrant community—take a virtual tour today!",
  "property_copyright": "2025 All Rights Reserved. The Alden South Hills",
  "property_seo_title_home": "The Alden South Hills |  Apartments in Pittsburgh, PA",
  "property_seo_description_home": "Discover comfort at The Alden South Hills in Pittsburgh! Choose from studios to townhomes with a pool, dog park, and resident lounge.",
  "property_seo_title_floorplans": "Floor Plans | Pittsburgh, PA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at The Alden South Hills in Pittsburgh, PA. From cozy studios to spacious three-bedrooms, your perfect floor plan awaits!",
  "property_seo_title_amenities": "Amenities | Pittsburgh, PA Apartments for Rent",
  "property_seo_description_amenities": "Discover life at The Alden South Hills, Pittsburgh! Enjoy luxurious amenities like a pool and vibrant community activities. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Pittsburgh, PA",
  "property_seo_description_gallery": "Experience vibrant living at The Alden South Hills in Pittsburgh—featuring stunning amenities, spacious layouts, and a pet-friendly atmosphere!",
  "property_seo_title_virtualtours": "Virtual Tours | The Alden South Hills Apartments",
  "property_seo_description_virtualtours": "Experience upscale living at The Alden South Hills in Pittsburgh, PA. Take a virtual tour of our diverse floor plans—studio to three-bedroom homes await!",
  "property_seo_title_interactivemap": "Interactive Map | The Alden South Hills Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Alden South Hills in Pittsburgh! Use our interactive map to explore spacious layouts, top amenities, and vibrant community life.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Pittsburgh, PA",
  "property_seo_description_neighborhood": "Uncover the charm surrounding The Alden South Hills in Pittsburgh, PA. Dive into local favorites and hidden gems just steps from your new home!",
  "property_seo_title_contact": "Contact Us | The Alden South Hills",
  "property_seo_description_contact": "Experience comfort at The Alden South Hills in Pittsburgh! With studio to three-bedroom floor plans, our leasing team is ready to assist you. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Pittsburgh, PA",
  "property_seo_description_faqs": "Find answers on our FAQs page for The Alden South Hills, covering amenities and pet policies—ideal for future residents!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Pittsburgh, PA",
  "property_seo_description_reviews": "Join the vibrant community at The Alden South Hills in Pittsburgh, PA. See why our residents love their homes filled with amenities and engaging activities!",
  "property_seo_title_applynow": "Apply Now | Apartments in Pittsburgh, PA",
  "property_seo_description_applynow": "Experience vibrant living at The Alden South Hills! Enjoy modern amenities, diverse floor plans, and a pet-friendly community in Pittsburgh!",
  "property_seo_title_residentaccess": "Resident Access | The Alden South Hills",
  "property_seo_description_residentaccess": "Unlock seamless living at The Alden South Hills! Access your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | The Alden South Hills",
  "property_seo_description_referafriend": "Share the joy of living at The Alden South Hills! Refer a friend today and inspire them to join our vibrant community in beautiful Pittsburgh, PA.",
  "property_seo_title_scheduletour": "Schedule a Tour | The Alden South Hills",
  "property_seo_description_scheduletour": "Step into luxury at The Alden South Hills in Pittsburgh, PA. Experience modern living and unique amenities—schedule your tour today! Your dream home awaits.",
  "property_seo_title_privacy": "Privacy Policy | The Alden South Hills",
  "property_seo_description_privacy": "Your privacy matters at The Alden South Hills. Learn how we protect your information in our detailed privacy policy. Read more to stay informed!",
  "property_seo_title_accessibility": "Website Accessibility | The Alden South Hills",
  "property_seo_description_accessibility": "At The Alden South Hills in Pittsburgh, we prioritize accessibility and digital inclusion, ensuring a comfortable living experience for everyone. Join us!",
  "property_seo_title_sitemap": "Sitemap | The Alden South Hills",
  "property_seo_description_sitemap": "Find your way around The Alden South Hills in Pittsburgh! Our sitemap guides you to amenities, floor plans, and everything our vibrant community offers.",
  "property_seo_title_thankyou": "Thank You | The Alden South Hills",
  "property_seo_description_thankyou": "Thank you for reaching out to The Alden South Hills! Our team will be in touch soon to help you discover your perfect home in Pittsburgh’s vibrant South Hills.",
  "property_seo_title_pets": "Pet Policy | Apartments in Pittsburgh, PA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293568968",
  "amenities": [
    {
      "id": "custom_61297146-ef7e-483b-bed4-8580677b46e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_87e5e325-7581-4b79-a015-681483a3d3d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fba3c78b-27d6-4d6f-bd2b-f8aad2df4aac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0c6ca911-9c22-4687-a21d-c7968154909d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Community Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ed0bf576-f51e-47ac-8f9a-098911f30a65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_58e2470e-ab8b-47c1-ac73-b3fb348b700d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_44cf5406-4365-4987-9614-cba5ec0f94fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_289f890b-8457-4857-9062-8989f747f0df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_32b8b515-0d5c-42fb-ac1a-3c6b6505d902",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0a8a1db7-07a0-4f7c-a2d0-7c0ccbab2ee6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3ee4b705-befc-4599-bcd9-e597b5e6d547",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e07e955f-1aab-4fac-9fbf-3fdacc969ad3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Wi-Fi in Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bacfd193-c6dd-4315-815a-e48b3baecedf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ec2ac5f-850e-4ac9-a0d5-fbb4dbb1ad94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Black Appliances*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eb30f273-eb11-4d1e-aecb-9ca2ecfc09d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast Bar*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6c76e82-79b3-4709-880c-3a5490d08ee4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6cdb327a-383b-4988-a83b-cb2dc0fce284",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Espresso Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f02f09ac-88e5-48f9-9b76-9a522ff3feb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Available",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e8ba3efd-e6c7-4ef9-8517-9c289d9062be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer & Dryer*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ada91d88-b779-4c80-a727-d1461da29c37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d7372a94-b9dc-4961-b10f-844292c7182a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c4b389f-6299-469f-b8ff-f01eccb0b980",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Oak Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a5ac54a0-d21c-475f-ad22-b5db8622a9a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Private Entrances",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64faea27-c177-4b55-b549-2ea5ddfb6a14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Subway Tile Backsplash*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9458544a-bbdc-4648-9bf6-a90e8b188445",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Plank Flooring*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38ba319f-af9c-4d00-9c85-0b84c5f050f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Walking Distance to Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59d9ae6f-f1cd-4f66-b789-59ee44b1fc8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_517f0b45-9faa-4fa0-85e5-1154c3b17600",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e4f15c32-a27a-495d-aadb-ccf61fe7a1b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Pavilion",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_021c2b45-7140-43c3-9576-ea8f22188ea8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Lounge",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f6b72860-bc9a-4452-a83c-ae94146ea5ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8aea7557-e963-4e13-9b5b-3f63e6d8616a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_47fbfbec-3d0c-4c87-bded-82cc814123b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_57d7ad3e-073b-4761-b4de-373dca4c0a1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_871362c8-c820-4fdd-980f-d7c2fa7da06a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-1387-763a-96a2-e42cd718dd42.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, subway tile backsplash, black appliances, and a wine rack.",
        "public_id": "019fce0b-1387-763a-96a2-e42cd718dd42",
        "storage_key": "property/6767906449166347/019fce0b-1387-763a-96a2-e42cd718dd42.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, stainless steel appliances, and a stylish subway tile backsplash, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen in an apartment with dark wood cabinets, black appliances, and a sink by a window at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/29633cfba308466a40a6b0092bfcb49c-4a389bbb.jpg"
    },
    {
      "id": "custom_23e10349-a8b7-4bcb-a11e-378c23c316e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-1317-716c-a71b-1d92edd5b8af.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, black appliances, and granite countertops.",
        "public_id": "019fce0b-1317-716c-a71b-1d92edd5b8af",
        "storage_key": "property/6767906449166347/019fce0b-1317-716c-a71b-1d92edd5b8af.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen featuring light wood cabinets, dark countertops, and black appliances.",
      "link": "false",
      "alt_text": "Apartment kitchen with light wood cabinets, black appliances, and dark countertops at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/7a1c402c2c5e75741102f3b804eccd74-9cdc4d3a.jpg"
    },
    {
      "id": "custom_9d3b60df-167e-4b10-b969-ed8f0d573459",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-1324-70af-8c4e-4aa6d3b27d12.webp",
      "image_media": {
        "alt_text": "Stylish living room with a comfortable sofa, armchair, coffee table, and decorative mirror.",
        "public_id": "019fce0b-1324-70af-8c4e-4aa6d3b27d12",
        "storage_key": "property/6767906449166347/019fce0b-1324-70af-8c4e-4aa6d3b27d12.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Apartment",
      "description": "Relax in the spacious and elegantly furnished living room, perfect for unwinding or entertaining guests.",
      "link": "false",
      "alt_text": "Living room in a modern apartment with a beige sofa, blue armchair, coffee table, and window at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/fb910b21dfeb6c00495e7d8be7bd0375-0d3be854.jpg"
    },
    {
      "id": "custom_a0ddead3-e3f0-4474-abc3-f9f4488e1c09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-12d7-7715-98ef-0886b0caa599.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-sized bed, ceiling fan, and large mirror.",
        "public_id": "019fce0b-12d7-7715-98ef-0886b0caa599",
        "storage_key": "property/6767906449166347/019fce0b-12d7-7715-98ef-0886b0caa599.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "A modern apartment bedroom featuring a neutral palette, plush bedding, and a large leaning mirror.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a bed, dresser, and a leaning floor mirror at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/56df64c25726d7612b5fd5dcbc5a5dba-9a6e7180.webp"
    },
    {
      "id": "custom_81758483-3464-4848-843b-da5b4d383ae4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-1e55-76da-a9f9-a7b9a6986c4b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and a breakfast bar.",
        "public_id": "019fce0b-1e55-76da-a9f9-a7b9a6986c4b",
        "storage_key": "property/6767906449166347/019fce0b-1e55-76da-a9f9-a7b9a6986c4b.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Apartment",
      "description": "Open-concept kitchen in a modern apartment with dark wood cabinets, black appliances, and a granite island.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, black appliances, and a granite island with seating at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/5a454f9d2a7e8875332cc2e9333e4299-ead5f238.jpg"
    },
    {
      "id": "custom_3dea6b88-8bee-44c9-8d98-1f8960b97ef3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-1e76-773c-a190-6abc9f9bd6bb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, white subway tile backsplash, black appliances, and a wine rack.",
        "public_id": "019fce0b-1e76-773c-a190-6abc9f9bd6bb",
        "storage_key": "property/6767906449166347/019fce0b-1e76-773c-a190-6abc9f9bd6bb.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Discover the sleek and functional kitchen in our apartments, featuring dark cabinetry, a subway tile backsplash, and essential black appliances for all your culinary needs.",
      "link": "false",
      "alt_text": "Compact modern kitchen with black appliances, white subway tile, and a wine rack at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/53f85ff3a2e4984a16c6479f606fe9d6-198b245c.jpg"
    },
    {
      "id": "custom_83247353-5085-457e-8e95-d290e70ba679",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-1e80-7241-a853-314b887476e3.webp",
      "image_media": {
        "alt_text": "Modern living room with a dark gray sectional sofa, coffee table, TV, and large windows.",
        "public_id": "019fce0b-1e80-7241-a853-314b887476e3",
        "storage_key": "property/6767906449166347/019fce0b-1e80-7241-a853-314b887476e3.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Modern apartment living room with a charcoal sofa, round coffee tables, TV console, window with dark curtains, and a plant.",
      "link": "false",
      "alt_text": "Living room in an apartment with a dark gray sofa, coffee table, curtains, TV stand, and a plant at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/5b2efad9a7be1cdae895ca1eabb8796e-1a895b1d.webp"
    },
    {
      "id": "custom_a1848208-1c42-4f01-a1ea-2a99c90f1c52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-210c-7359-b468-351c0e732f74.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, TV, coffee table, and plant.",
        "public_id": "019fce0b-210c-7359-b468-351c0e732f74",
        "storage_key": "property/6767906449166347/019fce0b-210c-7359-b468-351c0e732f74.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a modern sectional sofa, entertainment center with a TV, and a coffee table with decorative candles. Includes a view into the kitchen.",
      "link": "false",
      "alt_text": "Living room in a modern apartment with a black sectional sofa, round coffee table, TV, and a potted plant at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/a469c90c6a7f5e248cac33c8ac6debc7-7f6204f8.jpg"
    },
    {
      "id": "custom_ef138fd2-7db7-43ac-962c-fecfee832963",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-29f1-77cb-a7b9-a46afd0fe400.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, blue blanket, and modern dresser.",
        "public_id": "019fce0b-29f1-77cb-a7b9-a46afd0fe400",
        "storage_key": "property/6767906449166347/019fce0b-29f1-77cb-a7b9-a46afd0fe400.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Apartment",
      "description": "Relax in the spacious bedroom, featuring a comfortable queen-size bed with a stylish blue throw blanket, and ample storage with a modern dresser.",
      "link": "false",
      "alt_text": "Furnished apartment bedroom with a bed, dresser, two nightstands, and blinds on two windows at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/4387aa4e00344c0c54d5fb7e3c099095-e7c3bb35.jpg"
    },
    {
      "id": "custom_aec7caac-f67d-468f-982c-1ec22f596454",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-2a30-71ee-8679-ec37f30a1fce.webp",
      "image_media": {
        "alt_text": "Bedroom with closet, ceiling fan, and bedside table.",
        "public_id": "019fce0b-2a30-71ee-8679-ec37f30a1fce",
        "storage_key": "property/6767906449166347/019fce0b-2a30-71ee-8679-ec37f30a1fce.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a spacious closet, a modern ceiling fan, and a stylish bedside table with a lamp.",
      "link": "false",
      "alt_text": "Bedroom interior with a bed, nightstand, ceiling fan, and an open closet at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/eaa662f01d12ef8ed15d5ad340cd3ca0-118cb969.jpg"
    },
    {
      "id": "custom_9824e9c2-1878-43b3-8b0f-6da8aee4d8c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-2a2a-763d-96a4-6fe89ad805c2.webp",
      "image_media": {
        "alt_text": "Pedestal sink and bathtub with shower curtain in apartment bathroom",
        "public_id": "019fce0b-2a2a-763d-96a4-6fe89ad805c2",
        "storage_key": "property/6767906449166347/019fce0b-2a2a-763d-96a4-6fe89ad805c2.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with pedestal sink, tub/shower combo, white tile surround, mirror, and minimal decor.",
      "link": "false",
      "alt_text": "Small white apartment bathroom with pedestal sink, tub/shower, mirror, and a dark shower curtain at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/5767906449162442/6767906449166347/5d3d3470b0690ad290a636e3a4f0d4aa.jpg"
    },
    {
      "id": "custom_3dc37459-3853-4b97-ac2c-029bd7844661",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-2bac-76af-8107-fc1d3574f005.webp",
      "image_media": {
        "alt_text": "Community lounge area with a stone fireplace, TV, seating, and a table with chairs.",
        "public_id": "019fce0b-2bac-76af-8107-fc1d3574f005",
        "storage_key": "property/6767906449166347/019fce0b-2bac-76af-8107-fc1d3574f005.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "Relax and unwind in the community lounge, featuring a cozy fireplace and comfortable seating areas. Perfect for socializing or quiet enjoyment.",
      "link": "false",
      "alt_text": "Common lounge area with a stone fireplace, wall-mounted TV, and tan seating at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/a16228c846aa0371ed79613c4103d83e-4e5b4ae5.jpg"
    },
    {
      "id": "custom_b2e6546d-95eb-4460-bbd2-402316a914b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-347c-7121-9375-95e7092887c3.webp",
      "image_media": {
        "alt_text": "Treadmills in the fitness center.",
        "public_id": "019fce0b-347c-7121-9375-95e7092887c3",
        "storage_key": "property/6767906449166347/019fce0b-347c-7121-9375-95e7092887c3.webp",
        "width": 1280,
        "height": 967
      },
      "title": "Community",
      "description": "On-site fitness center with treadmills and a wall-mounted TV for residents.",
      "link": "false",
      "alt_text": "Interior fitness center with two treadmills and a wall-mounted TV at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/293d8519d8e633decc93fa2954a958ed-e311d5d5.jpg"
    },
    {
      "id": "custom_5dd704de-204d-480f-949a-9d68d310e24b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-355c-734d-be45-1d23aa698109.webp",
      "image_media": {
        "alt_text": "Gym with weight machine and recumbent bike.",
        "public_id": "019fce0b-355c-734d-be45-1d23aa698109",
        "storage_key": "property/6767906449166347/019fce0b-355c-734d-be45-1d23aa698109.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a weight machine and a recumbent bike for your cardio and strength training needs.",
      "link": "false",
      "alt_text": "Interior gym in an apartment community with cardio machines and weight equipment at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/9949c224e8f24681d4a6f39cbb6f7f1a-c0128c27.jpg"
    },
    {
      "id": "custom_b7dd1cf7-9b1e-46e7-bfc6-b8ad746019a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-362f-762a-8ce0-505f86ee843a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background at dusk.",
        "public_id": "019fce0b-362f-762a-8ce0-505f86ee843a",
        "storage_key": "property/6767906449166347/019fce0b-362f-762a-8ce0-505f86ee843a.webp",
        "width": 1280,
        "height": 967
      },
      "title": "Community",
      "description": "Photo of the communal swimming pool area at the property, with lounge chairs and brick buildings in the background",
      "link": "false",
      "alt_text": "Outdoor apartment community pool at dusk with lounge chairs and brick buildings in background at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/98535d936197d0edf9d0e8f74e04f13f-605664ed.webp"
    },
    {
      "id": "custom_352068cb-3050-4967-8728-ce80ba27ed33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-375a-71bf-b247-e554fb34cb72.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures adjacent to brick apartment buildings.",
        "public_id": "019fce0b-375a-71bf-b247-e554fb34cb72",
        "storage_key": "property/6767906449166347/019fce0b-375a-71bf-b247-e554fb34cb72.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and climbing structures perfect for family recreation.",
      "link": "false",
      "alt_text": "Colorful playground with slide and climbing structure in apartment complex courtyard at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/dd8be83591b657c5f1deecfa178bc913-a44d6a95.jpg"
    },
    {
      "id": "custom_58beb401-fe35-400d-b0f1-0575b4acefd9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-3f3f-72c1-8bd4-b5117f33df2a.webp",
      "image_media": {
        "alt_text": "Playground with slide and climbing wall at a multifamily property.",
        "public_id": "019fce0b-3f3f-72c1-8bd4-b5117f33df2a",
        "storage_key": "property/6767906449166347/019fce0b-3f3f-72c1-8bd4-b5117f33df2a.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "Outdoor playground at the apartment community with a multi-structure playset and slide on a wood-chip surface.",
      "link": "false",
      "alt_text": "Playground with a slide and climbing structure at a residential complex on a wood-chip surface at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/d90fa2316e4880d3b0d060f63777cfed-25947728.jpg"
    },
    {
      "id": "custom_e2e05b64-f6e4-4743-bbe4-995db036d5b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-4058-7061-b53e-b224549e4d61.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building at dusk.",
        "public_id": "019fce0b-4058-7061-b53e-b224549e4d61",
        "storage_key": "property/6767906449166347/019fce0b-4058-7061-b53e-b224549e4d61.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "Beautifully lit exterior of apartment buildings at dusk, showcasing the property's architecture and landscaping.",
      "link": "false",
      "alt_text": "Exterior view of a two-story apartment complex at dusk with lit windows and landscaped grounds at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/cb354d15ad4dde0688c0ce50e842ca73-18d4fcb2.jpg"
    },
    {
      "id": "custom_019f974c-6a93-46fc-9f8a-c22a4a06967a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-422f-70c6-b859-168c09e1e468.webp",
      "image_media": {
        "alt_text": "Pittsburgh skyline at dusk with rivers and bridges",
        "public_id": "019fce0b-422f-70c6-b859-168c09e1e468",
        "storage_key": "property/6767906449166347/019fce0b-422f-70c6-b859-168c09e1e468.webp",
        "width": 2000,
        "height": 1100
      },
      "title": "Other",
      "description": "Dramatic cityscape with illuminated skyscrapers and a river at dusk, used as an exterior backdrop in a multifamily property's photo gallery.",
      "link": "false",
      "alt_text": "Aerial view of a city skyline with a river and bridges at dusk at The Alden South Hills in Pittsburgh, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ef1481cd/dms3rep/multi/882ddc93c39cd8ff619209240eb3e82e-78443ce8.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_91ddf2a2-7ada-4930-89d3-112ebe61bc6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Ma and Pop's Country Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2840 South Park Rd, Bethel Park, PA 15102, USA",
      "poi_short_description": "Casual diner that serves home-style eats such as fried cheese, pancakes, burgers, and steak and eggs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-5465-7428-b614-fcf58ce2ffaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-5465-7428-b614-fcf58ce2ffaf",
        "storage_key": "property/6767906449166347/019fce0b-5465-7428-b614-fcf58ce2ffaf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4713401530119021510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ma-and-pops-country-kitchen",
      "poi_latitude": "40.3282935",
      "poi_longitude": "-80.0378441",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 412-595-8451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzd08ehT5NIgRxuOGDrhdaUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d5909b4c-e6f2-4e68-8905-6a0253d65abc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Family Deli",
      "poi_type": "Restaurants",
      "poi_address": "3400 South Park Rd, Bethel Park, PA 15102, USA",
      "poi_short_description": "Casual family-owned eatery specializing in hot and cold sandwiches served on fresh bread.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-536e-765c-bd23-f9599657d113.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-536e-765c-bd23-f9599657d113",
        "storage_key": "property/6767906449166347/019fce0b-536e-765c-bd23-f9599657d113.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.familydeli-bethelpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15512505373765853828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-deli",
      "poi_latitude": "40.3220981",
      "poi_longitude": "-80.057339",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-835-9939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d78b-708d-9a28-d39bfd5cce7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d78b-708d-9a28-d39bfd5cce7f",
        "storage_key": "property/6767906449166347/019d026b-d78b-708d-9a28-d39bfd5cce7f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_2e-Pvz4NIgRhOKm23J9R9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3024b5da-c9aa-4dd8-967a-7de904718f31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Bruegger's Bagels",
      "poi_type": "Restaurants",
      "poi_address": "5213 Library Rd, Bethel Park, PA 15102, USA",
      "poi_short_description": "Cafe/bakery chain preparing small-batch, New York-style bagels, plus breakfast & lunch sandwiches.",
      "poi_long_description": "Cafe/bakery chain preparing small-batch, New York-style bagels, plus breakfast & lunch sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-5395-737a-8609-3aad0329cac9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-5395-737a-8609-3aad0329cac9",
        "storage_key": "property/6767906449166347/019fce0b-5395-737a-8609-3aad0329cac9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.brueggers.com/us/pa/bethel-park/5213-library-road?y_source=1_OTczMjEyMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13586445476949534048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brueggers-bagels",
      "poi_latitude": "40.3333352",
      "poi_longitude": "-80.02323319999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 412-833-9381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQea_QJr5NIgRYCXKXS3AjLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f9e73f6e-d60f-42bb-8e50-bf8ad6975e2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Waffles, INCaffeinated, Upper St. Clair",
      "poi_type": "Restaurants",
      "poi_address": "155 McMurray Rd, Pittsburgh, PA 15241, USA",
      "poi_short_description": "Creatively topped waffles are the draw at this breakfast spot also dishing up eggs & crêpes.",
      "poi_long_description": "Creatively topped waffles are the draw at this breakfast spot also dishing up eggs & crêpes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-536c-739c-842c-5584328a36bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-536c-739c-842c-5584328a36bd",
        "storage_key": "property/6767906449166347/019fce0b-536c-739c-842c-5584328a36bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wafflesincaffeinated.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16425267262645965137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waffles-incaffeinated-upper-st-clair",
      "poi_latitude": "40.3253415",
      "poi_longitude": "-80.0649737",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 412-595-8393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3alUCUX5NIgRUZHd8oxF8uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_117375c9-c66d-4070-9644-656766194492",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "1835 Washington Rd, Upper St. Clair, PA 15241, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-5a3e-77b0-8776-044774ee04f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-5a3e-77b0-8776-044774ee04f6",
        "storage_key": "property/6767906449166347/019fce0b-5a3e-77b0-8776-044774ee04f6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.bonefishgrill.com/pennsylvania/upper-st.-clair/1835-washington-road?y_source=1_MTU1MDI4MzgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907296454626763537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "40.3452186",
      "poi_longitude": "-80.056343",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 412-835-3239",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL86RC0v4NIgREeNXcIel218",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d10a49b5-3bb5-41b6-9bfc-7d569c0566d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "The Porch",
      "poi_type": "Restaurants",
      "poi_address": "120 Siena Dr, Upper St Clair, PA 15241, USA",
      "poi_short_description": "Laid-back gathering place for seasonal menus crafted using ingredients from local producers.",
      "poi_long_description": "Laid-back gathering place for seasonal menus crafted using ingredients from local producers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-5a71-760a-8faf-6e9be43965aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-5a71-760a-8faf-6e9be43965aa",
        "storage_key": "property/6767906449166347/019fce0b-5a71-760a-8faf-6e9be43965aa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dineattheporch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030849979214556818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-porch",
      "poi_latitude": "40.3478248",
      "poi_longitude": "-80.0583383",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 412-833-5385",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0bFC0r4NIgRkm4x00sHLxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_787a248d-e03a-4e3e-a2ba-e3fa87df6a8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Gather Restaurant Pittsburgh",
      "poi_type": "Restaurants",
      "poi_address": "164 Fort Couch Rd, Pittsburgh, PA 15241, USA",
      "poi_short_description": "Casual, modern hotel eatery serving American comfort staples plus cocktails & craft beers.",
      "poi_long_description": "Casual, modern hotel eatery serving American comfort staples plus cocktails & craft beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-59e7-7358-beeb-56117ef04c95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-59e7-7358-beeb-56117ef04c95",
        "storage_key": "property/6767906449166347/019fce0b-59e7-7358-beeb-56117ef04c95.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ihg.com/crowneplaza/hotels/us/en/pittsburgh/pitso/hoteldetail/dining",
      "poi_directions_map_url": "https://maps.google.com/?cid=10475618707597261330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gather-restaurant-pittsburgh",
      "poi_latitude": "40.3457123",
      "poi_longitude": "-80.05279159999999",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-833-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ90hUJLX5NIgREnrFXLbfYJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_542f7d36-6df8-4d5e-970c-599a95f54402",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Bella's On Fort Couch",
      "poi_type": "Restaurants",
      "poi_address": "91 Fort Couch Rd, Pittsburgh, PA 15241, USA",
      "poi_short_description": "Established outpost for homemade ravioli & other classic Italian dishes served in a relaxed setting.",
      "poi_long_description": "Established outpost for homemade ravioli & other classic Italian dishes served in a relaxed setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-5bb9-747d-8339-6dfa799fad81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-5bb9-747d-8339-6dfa799fad81",
        "storage_key": "property/6767906449166347/019fce0b-5bb9-747d-8339-6dfa799fad81.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bellasonfortcouch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10822683084617259441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellas-on-fort-couch",
      "poi_latitude": "40.3390805",
      "poi_longitude": "-80.05205420000001",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 412-835-4320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQ666rL5NIgRsZk9p-zkMZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ae8407b7-59aa-475d-91a3-67085c6ae264",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "301 S Hills Village Upper, Upper St Clair, PA 15241, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-5fc9-764d-a4ca-5ce336e36990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-5fc9-764d-a4ca-5ce336e36990",
        "storage_key": "property/6767906449166347/019fce0b-5fc9-764d-a4ca-5ce336e36990.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/pa/bethelpark/south-hills-443?store_id=443&store_type=corporate&utm_campaign=local-business-listing&utm_content=website-link&utm_medium=organic-seach&utm_source=google-business-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=3164428788446788799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "40.342596",
      "poi_longitude": "-80.05484589999999",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 412-831-5610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs-5vrEz4NIgRv_xjnDdP6is",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8f6ecb14-0348-40f8-9748-97399a49dfef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "1819 Washington Rd, Upper St Clair, PA 15241, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-60e9-74c1-9893-6db32c851bbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-60e9-74c1-9893-6db32c851bbd",
        "storage_key": "property/6767906449166347/019fce0b-60e9-74c1-9893-6db32c851bbd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/pa/south-hills?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=16902875861325459541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "40.3450492",
      "poi_longitude": "-80.0554569",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-347-4790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO26j-kr4NIgRVTDUZAoUk-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_736fa2a2-e11a-4944-bb60-f05efd5cb854",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Condado Tacos",
      "poi_type": "Restaurants",
      "poi_address": "301 S Hills Village Space #2400, Pittsburgh, PA 15241, USA",
      "poi_short_description": "Colorful restaurant (part of a chain) dishing up customizable tacos alongside nachos and other Mexican eats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-60fe-74bd-9986-f6c57e2543cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-60fe-74bd-9986-f6c57e2543cf",
        "storage_key": "property/6767906449166347/019fce0b-60fe-74bd-9986-f6c57e2543cf.webp",
        "width": 1280,
        "height": 690
      },
      "poi_business_url": "https://locations.condadotacos.com/pa/301-south-hills-village?utm_source=GMB&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=14711778425227511811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "condado-tacos",
      "poi_latitude": "40.3419265",
      "poi_longitude": "-80.05500839999999",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-595-5717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL1FcPj75NIgRAwjxCYi8Ksw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_68e383fb-362e-4f38-966a-6c2cc56964d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Eat'n Park",
      "poi_type": "Restaurants",
      "poi_address": "301 S Hills Village, Pittsburgh, PA 15241, USA",
      "poi_short_description": "Family-friendly diner chain serving up all-day comfort food & signature Smiley Cookies.",
      "poi_long_description": "Family-friendly diner chain serving up all-day comfort food & signature Smiley Cookies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-63b4-715f-b1dc-96d7dfe702ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-63b4-715f-b1dc-96d7dfe702ae",
        "storage_key": "property/6767906449166347/019fce0b-63b4-715f-b1dc-96d7dfe702ae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.eatnpark.com/pa-pittsburgh-35/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6417359356147422972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eatn-park",
      "poi_latitude": "40.34109",
      "poi_longitude": "-80.0532468",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 412-854-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIcwFhUv4NIgR_FYyc1UKD1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8bbc02aa-a151-47f5-8080-5eb537813b5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Carnegie Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "132 E Main St, Carnegie, PA 15106, USA",
      "poi_short_description": "Hip, lofty coffeehouse in a former post office with Italian espresso & pastries, plus Sunday brunch.",
      "poi_long_description": "Hip, lofty coffeehouse in a former post office with Italian espresso & pastries, plus Sunday brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-657a-740c-86dd-4b58877cac54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-657a-740c-86dd-4b58877cac54",
        "storage_key": "property/6767906449166347/019fce0b-657a-740c-86dd-4b58877cac54.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://www.carnegiecoffeecompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11469043225811881964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carnegie-coffee-company",
      "poi_latitude": "40.4076664",
      "poi_longitude": "-80.0860764",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 412-275-3951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d78b-708d-9a28-d6889fbd2cf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d78b-708d-9a28-d6889fbd2cf5",
        "storage_key": "property/6767906449166347/019d026b-d78b-708d-9a28-d6889fbd2cf5.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJT085k833NIgR7A8eXAw6Kp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2f9f3874-aa8f-40c1-99f9-c4d57f69ee7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Lemonhead's Brightwood Grille",
      "poi_type": "Restaurants",
      "poi_address": "5317 Brightwood Rd, Bethel Park, PA 15102, USA",
      "poi_short_description": "Relaxed restaurant and bar offering comfort food, plus breakfast options, and happy hour.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-6708-731e-9bc5-4cfe1ed0d175.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-6708-731e-9bc5-4cfe1ed0d175",
        "storage_key": "property/6767906449166347/019fce0b-6708-731e-9bc5-4cfe1ed0d175.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://lemonheadsgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3305134247386106374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lemonheads-brightwood-grille",
      "poi_latitude": "40.327395",
      "poi_longitude": "-80.030103",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 412-835-9858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-5c80cde7ab0f",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-5c80cde7ab0f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4aWlp_5NIgRBkptLhYy3i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dcd5f0ee-d482-4e96-9adc-78eb22ec1843",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5190 Library Rd, Bethel Park, PA 15102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-66f9-77aa-ab13-cd7d5da9317a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-66f9-77aa-ab13-cd7d5da9317a",
        "storage_key": "property/6767906449166347/019fce0b-66f9-77aa-ab13-cd7d5da9317a.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/bethel-park-pa-pharmacies/5190-library-road-bethel-park-pa-15102/storeid=2447?WT.mc_id=LS_GOOGLE_RX_2447",
      "poi_directions_map_url": "https://maps.google.com/?cid=16856728691020772620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.3339711",
      "poi_longitude": "-80.0245236",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-833-6029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-6169506efc37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-6169506efc37",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-6169506efc37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98ewPZr5NIgRDLVtB28h7-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c61d143d-994c-417c-82f6-d0dd09e60def",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Giant Eagle Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "5055 Library Rd Suite 5, Bethel Park, PA 15102, USA",
      "poi_short_description": "Long-standing chain providing a variety of groceries, plus in-store pharmacies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-69e8-76c8-a600-be5b310e3a49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-69e8-76c8-a600-be5b310e3a49",
        "storage_key": "property/6767906449166347/019fce0b-69e8-76c8-a600-be5b310e3a49.webp",
        "width": 1280,
        "height": 610
      },
      "poi_business_url": "https://www.gianteagle.com/stores/pa/bethel-park/bethel-park-giant-eagle/4?utm_source=google&utm_medium=organic&utm_campaign=ge_ll",
      "poi_directions_map_url": "https://maps.google.com/?cid=17616472911582838390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant-eagle-supermarket",
      "poi_latitude": "40.3383508",
      "poi_longitude": "-80.0236108",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 412-833-8575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc2f-740b-9cb2-eb22965d30e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc2f-740b-9cb2-eb22965d30e9",
        "storage_key": "property/6767906449166347/019d026b-dc2f-740b-9cb2-eb22965d30e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVRbPJH5NIgRdr4v6sZIevQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_17a8313f-3034-42a3-b903-b558b75e3907",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "SHOP 'n SAVE",
      "poi_type": "Shopping & Retail",
      "poi_address": "5001 Library Rd, Bethel Park, PA 15102, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries & health & beauty products.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries & health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-6b99-762f-bf43-a5c3725cbea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-6b99-762f-bf43-a5c3725cbea4",
        "storage_key": "property/6767906449166347/019fce0b-6b99-762f-bf43-a5c3725cbea4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.shopnsavefood.com/StoreLocator/Store/?L=1630&S=",
      "poi_directions_map_url": "https://maps.google.com/?cid=11151070634648144172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shop-n-save",
      "poi_latitude": "40.3408777",
      "poi_longitude": "-80.02417",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-831-7177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc2f-740b-9cb2-eb22965d30e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc2f-740b-9cb2-eb22965d30e9",
        "storage_key": "property/6767906449166347/019d026b-dc2f-740b-9cb2-eb22965d30e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiV-355P5NIgRLAl-S6mPwJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9fc9fee2-15ae-4450-87fb-36054d4704cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "5169 Library Rd, Bethel Park, PA 15102, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-6d1e-7240-9a17-72e49c298b14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-6d1e-7240-9a17-72e49c298b14",
        "storage_key": "property/6767906449166347/019fce0b-6d1e-7240-9a17-72e49c298b14.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.aldi.us/pa/bethel-park/5169-library-road?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=7955159085905286361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "40.3348744",
      "poi_longitude": "-80.0228805",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc2f-740b-9cb2-eb22965d30e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc2f-740b-9cb2-eb22965d30e9",
        "storage_key": "property/6767906449166347/019d026b-dc2f-740b-9cb2-eb22965d30e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-f98vZD5NIgR2RQbVwpnZm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cda7f8dd-8826-4e77-a87b-e8704c1ff5f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Market District Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "7000 Oxford Dr #288, Bethel Park, PA 15102, USA",
      "poi_short_description": "Vast supermarket chain known for its vast array of local, international, organic and gourmet foods and beers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-6d21-75ab-8835-e999ececf2b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-6d21-75ab-8835-e999ececf2b1",
        "storage_key": "property/6767906449166347/019fce0b-6d21-75ab-8835-e999ececf2b1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.marketdistrict.com/stores/14?utm_source=google&utm_medium=organic&utm_campaign=md_ll",
      "poi_directions_map_url": "https://maps.google.com/?cid=15840063451820249989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-district-supermarket",
      "poi_latitude": "40.3469225",
      "poi_longitude": "-80.0466498",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 412-831-1480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc2f-740b-9cb2-eb22965d30e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc2f-740b-9cb2-eb22965d30e9",
        "storage_key": "property/6767906449166347/019d026b-dc2f-740b-9cb2-eb22965d30e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt7HbHrb5NIgRhdNkAck109s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b08d5658-74be-4e81-a3e0-2fb0edb59567",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 Library Rd, Bethel Park, PA 15102, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-6f85-758d-96bb-699e1b52d327.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-6f85-758d-96bb-699e1b52d327",
        "storage_key": "property/6767906449166347/019fce0b-6f85-758d-96bb-699e1b52d327.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/pa/bethel-park/817",
      "poi_directions_map_url": "https://maps.google.com/?cid=6945892430728748036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "40.342216",
      "poi_longitude": "-80.0267358",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-851-3895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d78b-708d-9a28-d39bfd5cce7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d78b-708d-9a28-d39bfd5cce7f",
        "storage_key": "property/6767906449166347/019d026b-d78b-708d-9a28-d39bfd5cce7f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJL99Vi5T5NIgRBFypZV3EZGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2054d9f8-160d-49c4-ad66-7eac4b683eda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "Curry Hollow Centre, 340 Curry Hollow Rd, Pittsburgh, PA 15236, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-72c1-703c-bc26-8c8a9726e8cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-72c1-703c-bc26-8c8a9726e8cc",
        "storage_key": "property/6767906449166347/019fce0b-72c1-703c-bc26-8c8a9726e8cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.familydollar.com/pa/pittsburgh/340-curry-hollow-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7354923121474026206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "40.337472",
      "poi_longitude": "-79.9772478",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 412-346-6179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d78b-708d-9a28-d39bfd5cce7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d78b-708d-9a28-d39bfd5cce7f",
        "storage_key": "property/6767906449166347/019d026b-d78b-708d-9a28-d39bfd5cce7f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ8OgkkT6NIgR3jrEZZzvEWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5f0c763d-9059-4711-b26e-5b38147ce607",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Sheetz",
      "poi_type": "Shopping & Retail",
      "poi_address": "251 Curry Hollow Rd, Pittsburgh, PA 15236, USA",
      "poi_short_description": "Chain offering fuel & familiar convenience goods, including packaged snacks, drinks & takeaway fare.",
      "poi_long_description": "Chain offering fuel & familiar convenience goods, including packaged snacks, drinks & takeaway fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-7384-773d-bef8-e7a9ae290608.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-7384-773d-bef8-e7a9ae290608",
        "storage_key": "property/6767906449166347/019fce0b-7384-773d-bef8-e7a9ae290608.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://orders.sheetz.com/#/main/location/store/253",
      "poi_directions_map_url": "https://maps.google.com/?cid=15361289841709140093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sheetz",
      "poi_latitude": "40.3362234",
      "poi_longitude": "-79.97071179999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 412-675-1712",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc35-732b-9f8d-f5ee36426965.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc35-732b-9f8d-f5ee36426965",
        "storage_key": "property/6767906449166347/019d026b-dc35-732b-9f8d-f5ee36426965.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJb6BtE1z6NIgRfcjjMrlDLtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_28e184e6-761a-44db-aac1-abfca2b87448",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "Curry Hollow Centre, 296 Curry Hollow Rd, Pleasant Hills, PA 15236, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-7319-70af-9287-e04d89087236.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-7319-70af-9287-e04d89087236",
        "storage_key": "property/6767906449166347/019fce0b-7319-70af-9287-e04d89087236.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.michaels.com/pa/pleasant-hills/8316/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=7702672247397892851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "40.33781219999999",
      "poi_longitude": "-79.9751793",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 412-653-8666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d78b-708d-9a28-d39bfd5cce7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d78b-708d-9a28-d39bfd5cce7f",
        "storage_key": "property/6767906449166347/019d026b-d78b-708d-9a28-d39bfd5cce7f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0z-NfJr7NIgR80JpN5lj5Wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dcdf4624-8bc6-4c6a-a1d1-f4372fa37868",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "South Hills Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "301 S Hills Village, Pittsburgh, PA 15241, USA",
      "poi_short_description": "Mall with upscale & mainstream shops, department stores, a cinema, a food court & restaurants.",
      "poi_long_description": "Mall with upscale & mainstream shops, department stores, a cinema, a food court & restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-75e5-7671-9014-3aab547fac60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-75e5-7671-9014-3aab547fac60",
        "storage_key": "property/6767906449166347/019fce0b-75e5-7671-9014-3aab547fac60.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.simon.com/mall/south-hills-village",
      "poi_directions_map_url": "https://maps.google.com/?cid=16912290782700718672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-hills-village",
      "poi_latitude": "40.3423193",
      "poi_longitude": "-80.0561022",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-831-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d78b-708d-9a28-d39bfd5cce7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d78b-708d-9a28-d39bfd5cce7f",
        "storage_key": "property/6767906449166347/019d026b-d78b-708d-9a28-d39bfd5cce7f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIcwFhUv4NIgRUEr9mNyGtOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1221973d-fdad-4d44-a324-190e0f74e909",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "McAnnulty Elementary School",
      "poi_type": "Education",
      "poi_address": "5151 McAnulty Rd, Pittsburgh, PA 15236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bwschools.net/mcannulty-elementary-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=11916486798911189299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcannulty-elementary-school",
      "poi_latitude": "40.3452169",
      "poi_longitude": "-79.9958971",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-714-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf6rBoxf6NIgRM7G7e5vdX6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1d90eb1c-649e-4325-9281-36a6bfde0c42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "J.E. Harrison Education Center",
      "poi_type": "Education",
      "poi_address": "129 Windvale Dr, Pittsburgh, PA 15236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-794e-76e8-86a0-9ec89595e17b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-794e-76e8-86a0-9ec89595e17b",
        "storage_key": "property/6767906449166347/019fce0b-794e-76e8-86a0-9ec89595e17b.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.bwschools.net/hec/about-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=1543478337545055076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "je-harrison-education-center",
      "poi_latitude": "40.3506897",
      "poi_longitude": "-80.00015619999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-885-7530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6wF-_hr6NIgRZCviy16JaxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a21dc4a0-cfec-4774-a642-f8883ba8d69f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Baldwin High School",
      "poi_type": "Education",
      "poi_address": "4653 Clairton Blvd, Pittsburgh, PA 15236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-7988-77c1-9afe-21f88771b60c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-7988-77c1-9afe-21f88771b60c",
        "storage_key": "property/6767906449166347/019fce0b-7988-77c1-9afe-21f88771b60c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bwschools.net/baldwin-high-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=4358604099592156201&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baldwin-high-school",
      "poi_latitude": "40.3556074",
      "poi_longitude": "-79.9783741",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-885-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQxaR3XD6NIgRKXTA8FXffDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1ad8eb5f-cf5c-40e3-a485-8aa60468ef3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Whitehall Elementary School",
      "poi_type": "Education",
      "poi_address": "4900 Curry Rd, Pittsburgh, PA 15236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bwschools.net/whitehall-elementary-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=2779390336500066971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whitehall-elementary-school",
      "poi_latitude": "40.352481",
      "poi_longitude": "-79.994112",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-885-7525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW0JHBQ76NIgRm2o9A8lgkiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7daee2d3-fd40-475c-989b-615dcae79c13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Mother of Mercy Academy",
      "poi_type": "Education",
      "poi_address": "5200 Greenridge Dr, Pittsburgh, PA 15236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.motherofmercyacademy.org/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=14310396690259148123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mother-of-mercy-academy",
      "poi_latitude": "40.3561334",
      "poi_longitude": "-80.00627109999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 412-882-3353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHcNr_AL6NIgRW33SVfi9mMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_23558445-1553-4711-abd4-bb1e594c3854",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Tutor Time of Pittsburgh",
      "poi_type": "Education",
      "poi_address": "6031 Baptist Rd, Pittsburgh, PA 15236, USA",
      "poi_short_description": "Educational preschool and daycare featuring classrooms streamed to an app, meals, and outdoor activities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-79ae-76eb-ac8c-10937d5817e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-79ae-76eb-ac8c-10937d5817e4",
        "storage_key": "property/6767906449166347/019fce0b-79ae-76eb-ac8c-10937d5817e4.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.tutortime.com/your-local-school/pittsburgh-pa-6061/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=6061",
      "poi_directions_map_url": "https://maps.google.com/?cid=811900121766000803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tutor-time-of-pittsburgh",
      "poi_latitude": "40.3435932",
      "poi_longitude": "-80.014428",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-887-8945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe6GhoYz5NIgRo3j17ttyRAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ddd7c685-a59c-4de3-bb1c-d5fe042875b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Bright and Early Learning and Child Care Center",
      "poi_type": "Education",
      "poi_address": "5001 Baptist Rd 2nd floor, Pittsburgh, PA 15236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://brightandearlypgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14848251343662261575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-and-early-learning-and-child-care-center",
      "poi_latitude": "40.3572051",
      "poi_longitude": "-79.9999205",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-881-7330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO67MKDv7NIgRR6W0eu2VD84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c1f385b7-86b4-43ae-98c9-9d5142913cb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "CCAC South Campus",
      "poi_type": "Education",
      "poi_address": "1750 Clairton Rd #885, West Mifflin, PA 15122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-7caa-751f-9008-a10d8e0e38ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-7caa-751f-9008-a10d8e0e38ce",
        "storage_key": "property/6767906449166347/019fce0b-7caa-751f-9008-a10d8e0e38ce.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ccac.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17066134947627853542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ccac-south-campus",
      "poi_latitude": "40.3298505",
      "poi_longitude": "-79.9241483",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 412-469-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb7-WMcz6NIgR5uY8ilAX1-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3dc32a16-f768-4a82-ba3f-30355bd0c099",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "South Hills Catholic Academy",
      "poi_type": "Education",
      "poi_address": "550 Sleepy Hollow Rd Suite 2, Mt. Lebanon, PA 15228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-7f23-76bc-a979-8c7d2a246d3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-7f23-76bc-a979-8c7d2a246d3c",
        "storage_key": "property/6767906449166347/019fce0b-7f23-76bc-a979-8c7d2a246d3c.webp",
        "width": 1280,
        "height": 867
      },
      "poi_business_url": "http://shcacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2374964959963994517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-hills-catholic-academy",
      "poi_latitude": "40.3754655",
      "poi_longitude": "-80.0233634",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 412-631-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ90kXzln3NIgRlVmnSAyS9SA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fc52bb1e-aee2-4c86-8f70-6f36835b3fa5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Seton LaSalle Catholic High School",
      "poi_type": "Education",
      "poi_address": "1000 McNeilly Rd, Pittsburgh, PA 15226, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-7f48-726c-9475-4ec680bbb62e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-7f48-726c-9475-4ec680bbb62e",
        "storage_key": "property/6767906449166347/019fce0b-7f48-726c-9475-4ec680bbb62e.webp",
        "width": 892,
        "height": 578
      },
      "poi_business_url": "http://www.slshs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7076617619330328239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seton-lasalle-catholic-high-school",
      "poi_latitude": "40.3874457",
      "poi_longitude": "-80.0267752",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 412-561-3583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn9ELNkr3NIgRr2Z0MzsyNWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e8af386a-efc3-49bf-a2b7-ef4294a82f97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "The Crafthouse Stage & Grill",
      "poi_type": "Entertainment",
      "poi_address": "5024 Curry Rd, Pittsburgh, PA 15236, USA",
      "poi_short_description": "Buzzy venue offering live music, pub grub & many craft beers on tap, plus a cigar bar & dance floor.",
      "poi_long_description": "Buzzy venue offering live music, pub grub & many craft beers on tap, plus a cigar bar & dance floor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-7ff7-7538-afc7-3371162b502b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-7ff7-7538-afc7-3371162b502b",
        "storage_key": "property/6767906449166347/019fce0b-7ff7-7538-afc7-3371162b502b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.crafthousepgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5349118492797746109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-crafthouse-stage--grill",
      "poi_latitude": "40.349887",
      "poi_longitude": "-79.9962369",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-653-2695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc2f-740b-9cb2-e4469c761658.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc2f-740b-9cb2-e4469c761658",
        "storage_key": "property/6767906449166347/019d026b-dc2f-740b-9cb2-e4469c761658.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx00RR__5NIgRvbuuqO3iO0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f526b2d4-d982-4102-b6c9-991e455313eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "AMC CLASSIC South Hills Village 10",
      "poi_type": "Entertainment",
      "poi_address": "700 Fort Couch Rd S. Hills, Pittsburgh, PA 15241, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-8443-74ef-ba79-181b2757d0ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-8443-74ef-ba79-181b2757d0ee",
        "storage_key": "property/6767906449166347/019fce0b-8443-74ef-ba79-181b2757d0ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/pittsburgh/amc-classic-south-hills-village-10?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6491883580104851822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-classic-south-hills-village-10",
      "poi_latitude": "40.3433775",
      "poi_longitude": "-80.0539289",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-835-7074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e053-75fc-b23e-247f230f503a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e053-75fc-b23e-247f230f503a",
        "storage_key": "property/6767906449166347/019d026b-e053-75fc-b23e-247f230f503a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJH4i4UEv4NIgRbkFXe7jNF1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3843388e-71e4-41cc-88bf-db4626f03559",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Century Square Luxury Cinemas",
      "poi_type": "Entertainment",
      "poi_address": "2001 Mountain View Dr, West Mifflin, PA 15122, USA",
      "poi_short_description": "Contemporary cinema offering current films in theaters with leather recliners, plus snacks & a pub.",
      "poi_long_description": "Contemporary cinema offering current films in theaters with leather recliners, plus snacks & a pub.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-85fc-752c-845e-08c8dc797520.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-85fc-752c-845e-08c8dc797520",
        "storage_key": "property/6767906449166347/019fce0b-85fc-752c-845e-08c8dc797520.webp",
        "width": 1248,
        "height": 683
      },
      "poi_business_url": "http://www.centurysquareluxurycinemas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16130075381275677578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "century-square-luxury-cinemas",
      "poi_latitude": "40.34695",
      "poi_longitude": "-79.946316",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-714-4746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e053-75fc-b23e-247f230f503a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e053-75fc-b23e-247f230f503a",
        "storage_key": "property/6767906449166347/019d026b-e053-75fc-b23e-247f230f503a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJq-GcPJf6NIgRitM1NRmK2d8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ac279928-b818-451a-9bfa-16d902f7e21b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "South Park",
      "poi_type": "Entertainment",
      "poi_address": "3730 Buffalo Dr, South Park Township, PA 15129, USA",
      "poi_short_description": "South Park County's 1,999-acre park offers sports, a wave pool, trails & a tourable old farmhouse.",
      "poi_long_description": "South Park County's 1,999-acre park offers sports, a wave pool, trails & a tourable old farmhouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-863a-70ba-913e-e733a480e12c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-863a-70ba-913e-e733a480e12c",
        "storage_key": "property/6767906449166347/019fce0b-863a-70ba-913e-e733a480e12c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alleghenycounty.us/Parks-and-Events/Parks/South-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=221460103181055332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-park",
      "poi_latitude": "40.3050315",
      "poi_longitude": "-79.9958479",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 412-350-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e04a-74d9-b464-629991932b71",
        "storage_key": "property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT4msLuv5NIgRZDUHXsrIEgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a2fcdd3e-0e67-4f68-8ebc-e1384ec54d9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "South Park Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "100 Farmshow Dr, South Park Township, PA 15129, USA",
      "poi_short_description": "Relaxed outdoor spot featuring summer concerts, a food van and a beer truck.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-86bc-74ea-9250-b35361cd7707.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-86bc-74ea-9250-b35361cd7707",
        "storage_key": "property/6767906449166347/019fce0b-86bc-74ea-9250-b35361cd7707.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.alleghenycounty.us/Parks-and-Events/Parks/South-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1889221656245927389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-park-amphitheater",
      "poi_latitude": "40.3027966",
      "poi_longitude": "-79.99530100000001",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-835-5710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ15J1hML7NIgR3X2DOhbdNxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_94feae2a-4124-4d98-a70f-5135bee288dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Oliver Miller Homestead",
      "poi_type": "Entertainment",
      "poi_address": "Buffalo Dr, South Park Township, PA 15129, USA",
      "poi_short_description": "Restored 1772 homestead featuring costumed guides, tours and blacksmithing demos, plus historical reenactments and kids' activities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-8bdc-7090-ab8a-67a2842384ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-8bdc-7090-ab8a-67a2842384ae",
        "storage_key": "property/6767906449166347/019fce0b-8bdc-7090-ab8a-67a2842384ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivermillerhomestead.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8105887419874069343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oliver-miller-homestead",
      "poi_latitude": "40.3200622",
      "poi_longitude": "-80.0065687",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-835-1554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e052-747f-b90f-5f8ea33a2979.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e052-747f-b90f-5f8ea33a2979",
        "storage_key": "property/6767906449166347/019d026b-e052-747f-b90f-5f8ea33a2979.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJd4ylHsP7NIgRX8vmWqnlfXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8fd1163e-ebf7-4715-a349-36252368b346",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Pittsburgh Zoo & Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "7370 Baker St, Pittsburgh, PA 15206, USA",
      "poi_short_description": "Animal center features an African Savanna, Asian Forest, Bear park, PPG Aquarium & Kids Kingdom.",
      "poi_long_description": "Animal center features an African Savanna, Asian Forest, Bear park, PPG Aquarium & Kids Kingdom.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-8d00-72be-8647-e8ca97ad2d9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-8d00-72be-8647-e8ca97ad2d9d",
        "storage_key": "property/6767906449166347/019fce0b-8d00-72be-8647-e8ca97ad2d9d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.pittsburghzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1981986378730085952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pittsburgh-zoo--aquarium",
      "poi_latitude": "40.4842648",
      "poi_longitude": "-79.922206",
      "poi_miles_from_property": "14.3 mi",
      "poi_walking_minutes": "5 hours 18 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 412-665-3640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWwT8oLyNIgRQJ7eRRxugRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b641b66a-71ab-4437-917d-4dd1d009b139",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Manor Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1729 Murray Ave, Pittsburgh, PA 15217, USA",
      "poi_short_description": "Landmark theater featuring independent films & documentaries, plus a cocktail bar with casual fare.",
      "poi_long_description": "Landmark theater featuring independent films & documentaries, plus a cocktail bar with casual fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-8dbf-74d0-9320-60107501b8e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-8dbf-74d0-9320-60107501b8e1",
        "storage_key": "property/6767906449166347/019fce0b-8dbf-74d0-9320-60107501b8e1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.manorpgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9950737258870902732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manor-theatre",
      "poi_latitude": "40.4371792",
      "poi_longitude": "-79.9228073",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 412-422-9851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e053-75fc-b23e-247f230f503a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e053-75fc-b23e-247f230f503a",
        "storage_key": "property/6767906449166347/019d026b-e053-75fc-b23e-247f230f503a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJC67EZP_xNIgRzI8-0NAeGIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eb4bb00b-ebed-49b4-aefc-b23372e09d4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Rivers Casino",
      "poi_type": "Entertainment",
      "poi_address": "777 Casino Dr, Pittsburgh, PA 15212, USA",
      "poi_short_description": "Casino with slots, craps, poker & other table games, plus several restaurants & live entertainment.",
      "poi_long_description": "Casino with slots, craps, poker & other table games, plus several restaurants & live entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-9063-708d-b5ba-041c26e2cf90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-9063-708d-b5ba-041c26e2cf90",
        "storage_key": "property/6767906449166347/019fce0b-9063-708d-b5ba-041c26e2cf90.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.riverscasino.com/pittsburgh",
      "poi_directions_map_url": "https://maps.google.com/?cid=3087430261728256882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rivers-casino",
      "poi_latitude": "40.4478179",
      "poi_longitude": "-80.023202",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 412-231-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwROTeR30NIgRcqMaE3fB2Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ca387a13-fef6-4a04-ab7f-29ea841312d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Senator John Heinz History Center",
      "poi_type": "Entertainment",
      "poi_address": "1212 Smallman St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Smithsonian affiliate has 6 floors of historical exhibits, archives & a separate sports museum.",
      "poi_long_description": "Smithsonian affiliate has 6 floors of historical exhibits, archives & a separate sports museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-9267-73ef-9e30-a40702730cf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-9267-73ef-9e30-a40702730cf4",
        "storage_key": "property/6767906449166347/019fce0b-9267-73ef-9e30-a40702730cf4.webp",
        "width": 1200,
        "height": 750
      },
      "poi_business_url": "http://www.heinzhistorycenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5087244111269421195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "senator-john-heinz-history-center",
      "poi_latitude": "40.4468415",
      "poi_longitude": "-79.9920696",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 412-454-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e052-747f-b90f-5f8ea33a2979.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e052-747f-b90f-5f8ea33a2979",
        "storage_key": "property/6767906449166347/019d026b-e052-747f-b90f-5f8ea33a2979.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJr7aBzePzNIgRi2Dp2ZCFmUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ac692b39-4ea6-4a77-a6ba-d82dce0b90bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "St. Clair Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 Bower Hill Rd, Pittsburgh, PA 15243, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-9259-7527-97d0-73ea35861bff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-9259-7527-97d0-73ea35861bff",
        "storage_key": "property/6767906449166347/019fce0b-9259-7527-97d0-73ea35861bff.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://reach-redirect.kyruus.com/v2?data=eyJ1cmwiOiJodHRwczovL3d3dy5zdGNsYWlyLm9yZy8iLCJwdWJsaXNoZXIiOiJHb29nbGUgQnVzaW5lc3MgUHJvZmlsZSIsInV0bVNvdXJjZSI6Imdvb2dsZV9idXNpbmVzc19wcm9maWxlIiwiY3RhVHlwZSI6IndlYnNpdGUiLCJjdXN0b21lckNvZGUiOiJzdGNsYWlyIiwibWFya2V0YWJsZUxvY2F0aW9uSWQiOiJMT0MwMDAwMTgxNTY3In0=",
      "poi_directions_map_url": "https://maps.google.com/?cid=3867219038858368232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-clair-hospital",
      "poi_latitude": "40.3779491",
      "poi_longitude": "-80.066761",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 412-942-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e521-7249-8492-0314b6247c2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e521-7249-8492-0314b6247c2f",
        "storage_key": "property/6767906449166347/019d026b-e521-7249-8492-0314b6247c2f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJb07TlY_3NIgR6NTH9zkfqzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4b98e16b-9f48-4154-b602-625ce95fccce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "St. Clair Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 Oxford Dr Ste 100, Bethel Park, PA 15102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-9348-761e-8fd8-fc93f3798821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-9348-761e-8fd8-fc93f3798821",
        "storage_key": "property/6767906449166347/019fce0b-9348-761e-8fd8-fc93f3798821.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://reach-redirect.kyruus.com/v2?data=eyJ1cmwiOiJodHRwczovL3d3dy5zdGNsYWlyLm9yZy9zZXJ2aWNlcy9hei1saXN0aW5nL3VyZ2VudC1jYXJlLyIsInB1Ymxpc2hlciI6Ikdvb2dsZSBCdXNpbmVzcyBQcm9maWxlIiwidXRtU291cmNlIjoiZ29vZ2xlX2J1c2luZXNzX3Byb2ZpbGUiLCJjdGFUeXBlIjoid2Vic2l0ZSIsImN1c3RvbWVyQ29kZSI6InN0Y2xhaXIiLCJtYXJrZXRhYmxlTG9jYXRpb25JZCI6IkxPQzAwMDAxODE1NjgifQ==",
      "poi_directions_map_url": "https://maps.google.com/?cid=15731311862318271975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-clair-urgent-care",
      "poi_latitude": "40.3440321",
      "poi_longitude": "-80.05249669999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-942-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-jNuLT5NIgR541ebMrYUNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eb8f0513-09c6-4ea5-877e-9dabe5e70ba2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "UPMC Outpatient Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1300 Oxford Dr, Bethel Park, PA 15102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-96b2-73aa-a85d-d77a25115680.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-96b2-73aa-a85d-d77a25115680",
        "storage_key": "property/6767906449166347/019fce0b-96b2-73aa-a85d-d77a25115680.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.upmc.com/locations/outpatient/southwest-pa/bethel-park?utm_source=google&utm_medium=organic&utm_campaign=business-profile&utm_content=outpatient-center-swpa-upmc-outpatient-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=5607430588967827432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upmc-outpatient-center",
      "poi_latitude": "40.3430658",
      "poi_longitude": "-80.0484434",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-851-8762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e521-7249-8492-0314b6247c2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e521-7249-8492-0314b6247c2f",
        "storage_key": "property/6767906449166347/019d026b-e521-7249-8492-0314b6247c2f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJcb8hBbT5NIgR6DcWRmmY0U0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ad5a48d0-0609-4982-9847-a1c9ef6d4313",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5242 Clairton Blvd, Pittsburgh, PA 15236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-9947-754b-968f-64dffe2788eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-9947-754b-968f-64dffe2788eb",
        "storage_key": "property/6767906449166347/019fce0b-9947-754b-968f-64dffe2788eb.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/pittsburgh-pa-pharmacies/5242-clairton-boulevard-pittsburgh-pa-15236/storeid=2333?WT.mc_id=LS_GOOGLE_RX_2333",
      "poi_directions_map_url": "https://maps.google.com/?cid=5528425664594568011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.3431167",
      "poi_longitude": "-79.9705081",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-885-5864",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-6169506efc37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-6169506efc37",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-6169506efc37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3VAeJ2f6NIgRS-NP4dnpuEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_716aa853-c95d-47f2-9de1-58654ac4190d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Giant Eagle Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5055 Library Rd Suite 5, Bethel Park, PA 15102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-9883-705e-96f5-fa5ef2638de8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-9883-705e-96f5-fa5ef2638de8",
        "storage_key": "property/6767906449166347/019fce0b-9883-705e-96f5-fa5ef2638de8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gianteagle.com/pharmacy?utm_source=google&utm_medium=organic&utm_campaign=rx_ll",
      "poi_directions_map_url": "https://maps.google.com/?cid=3309295201339311436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant-eagle-pharmacy",
      "poi_latitude": "40.3383974",
      "poi_longitude": "-80.0236968",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-831-7727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-d791-70fe-bb2e-6169506efc37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-d791-70fe-bb2e-6169506efc37",
        "storage_key": "property/6767906449166347/019d026b-d791-70fe-bb2e-6169506efc37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVRbPJH5NIgRTAW8xHP67C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0348c65e-0d67-47a9-96da-7f9650ff3a21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4 Old Clairton Rd, Pleasant Hills, PA 15236, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-98d4-748c-a426-11c7c962e4dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-98d4-748c-a426-11c7c962e4dc",
        "storage_key": "property/6767906449166347/019fce0b-98d4-748c-a426-11c7c962e4dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4+old+clairton+rd-pleasant+hills-pa-15236/id=9188",
      "poi_directions_map_url": "https://maps.google.com/?cid=6138879279966314067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.3406565",
      "poi_longitude": "-79.966357",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-650-7354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1fAKBmD6NIgRU95lES6uMVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3a4a7497-6b78-449d-97ba-c1d29492e6db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Spencer Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "305 Church Rd, Bethel Park, PA 15102, USA",
      "poi_short_description": "Gym featuring a pool and ice hockey rink, plus group classes including Zumba, for adults and kids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-9d4b-770a-a59a-7dba25580263.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-9d4b-770a-a59a-7dba25580263",
        "storage_key": "property/6767906449166347/019fce0b-9d4b-770a-a59a-7dba25580263.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.pittsburghymca.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14836845057466233587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spencer-family-ymca",
      "poi_latitude": "40.3372036",
      "poi_longitude": "-80.0442169",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 412-833-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF9RlY1j4NIgR8_LIhfgP580",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2caf9673-2898-4007-883d-1fbacab9cab7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "300 Mt Lebanon Blvd, Castle Shannon, PA 15234, USA",
      "poi_short_description": "Chain gym offering a variety of exercise equipment, tanning beds, and massages.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-9f43-753c-ac45-1d96a9af9cbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-9f43-753c-ac45-1d96a9af9cbb",
        "storage_key": "property/6767906449166347/019fce0b-9f43-753c-ac45-1d96a9af9cbb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/castle-shannon-pa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16258784195458343783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.3689216",
      "poi_longitude": "-80.0338161",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-318-8980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5apLpGH3NIgRZ6MHQhXOouE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_42afd7a0-9ce6-4fed-a800-0f44d993b975",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "301 S Hills Village, Pittsburgh, PA 15241, USA",
      "poi_short_description": "Cardio and strength studio offering group workouts designed around heart-rate zone training. Friendly staff and welcoming coaches help people get into the optimal zone.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-a08d-76c6-8dbf-09329bf8736d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-a08d-76c6-8dbf-09329bf8736d",
        "storage_key": "property/6767906449166347/019fce0b-a08d-76c6-8dbf-09329bf8736d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/bethel-park-pennsylvania-1033?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=11314462436437759452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "40.342939",
      "poi_longitude": "-80.05736569999999",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 412-275-0446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvU_bihD5NIgR3JVfrKMLBZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b0e7b669-151b-43dc-8fe5-d5482000c819",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Yoga Innovations",
      "poi_type": "Health and Wellness",
      "poi_address": "250 Mt Lebanon Blvd, Pittsburgh, PA 15234, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-9fd5-73af-827d-dc796a295a7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-9fd5-73af-827d-dc796a295a7e",
        "storage_key": "property/6767906449166347/019fce0b-9fd5-73af-827d-dc796a295a7e.webp",
        "width": 1280,
        "height": 1079
      },
      "poi_business_url": "http://yogainnovations.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8076675147590507353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoga-innovations",
      "poi_latitude": "40.3679993",
      "poi_longitude": "-80.0369174",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 412-440-8446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt2KevpT5NIgRWZtbMkEdFnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_65016150-c5ae-4693-ba98-9cb81db08709",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Miner's Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5440 Main St, Bethel Park, PA 15102, USA",
      "poi_short_description": "Neighborhood green space featuring 3 baseball fields, a playground, and a basketball court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-a4d7-710d-a500-ef0046ba1a27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-a4d7-710d-a500-ef0046ba1a27",
        "storage_key": "property/6767906449166347/019fce0b-a4d7-710d-a500-ef0046ba1a27.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bethelpark.net/recreation/municipal-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13453353380832176125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miners-memorial-park",
      "poi_latitude": "40.3217748",
      "poi_longitude": "-80.0371874",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 412-831-1328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e04a-74d9-b464-629991932b71",
        "storage_key": "property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNSTlNQn5NIgR_WdN9p7ps7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d3457de3-caeb-45ea-a24f-68c620590a9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Bethel Park Community Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5151 Park Ave, Bethel Park, PA 15102, USA",
      "poi_short_description": "Spacious community center featuring a large gymnasium, an indoor track and multiple rooms for classes, meetings and events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-a526-753a-ae7f-b82a88d1bfc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-a526-753a-ae7f-b82a88d1bfc5",
        "storage_key": "property/6767906449166347/019fce0b-a526-753a-ae7f-b82a88d1bfc5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.bethelparkpa.gov/community-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=4022181616900930694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bethel-park-community-center",
      "poi_latitude": "40.331078",
      "poi_longitude": "-80.0287601",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 412-851-2910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99GOzpj5NIgRhnx8wd6o0Tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a35ddb0-e729-43bc-ad1b-1d289faced61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Millennium Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5900 Baptist Rd, Bethel Park, PA 15102, USA",
      "poi_short_description": "Neat area with basketball and baseball fields and a playground, plus 10 pickleball courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-a771-76cd-9d20-6c8776a17d47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-a771-76cd-9d20-6c8776a17d47",
        "storage_key": "property/6767906449166347/019fce0b-a771-76cd-9d20-6c8776a17d47.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://bethelpark.net/recreation/municipal-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=324869051478911389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "millennium-park",
      "poi_latitude": "40.3492123",
      "poi_longitude": "-80.01809999999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-831-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e04a-74d9-b464-629991932b71",
        "storage_key": "property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhfcAQ_L5NIgRnSnrW64qggQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7a8f6d89-3f82-4294-ac7d-eea71ed8fab5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Simmons Pickleball Courts (2 Outdoor Dedicated Courts)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bethel Park, PA 15102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-a7e5-72eb-b895-1244e55b2fed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-a7e5-72eb-b895-1244e55b2fed",
        "storage_key": "property/6767906449166347/019fce0b-a7e5-72eb-b895-1244e55b2fed.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13944216052075408111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simmons-pickleball-courts-2-outdoor-dedicated-courts",
      "poi_latitude": "40.295203",
      "poi_longitude": "-80.0355782",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyjIPrf5NIgR7ypBp57Og8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_96a0d2ba-f9bc-45f7-94c9-b5cf5b4dc9a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Village Green Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7000 Alicia Dr, Bethel Park, PA 15102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-abd3-744b-8622-d9e53d39ae46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-abd3-744b-8622-d9e53d39ae46",
        "storage_key": "property/6767906449166347/019fce0b-abd3-744b-8622-d9e53d39ae46.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://bethelpark.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17068655335794592598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-green-park",
      "poi_latitude": "40.3476083",
      "poi_longitude": "-80.0435239",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-831-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e04a-74d9-b464-629991932b71",
        "storage_key": "property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUzGBGcj5NIgRVsucI5gL4Ow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_33e9d69d-38f5-4d7c-b141-5afbab8036c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "South Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3730 Buffalo Dr, South Park Township, PA 15129, USA",
      "poi_short_description": "South Park County's 1,999-acre park offers sports, a wave pool, trails & a tourable old farmhouse.",
      "poi_long_description": "South Park County's 1,999-acre park offers sports, a wave pool, trails & a tourable old farmhouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-863a-70ba-913e-e733a480e12c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-863a-70ba-913e-e733a480e12c",
        "storage_key": "property/6767906449166347/019fce0b-863a-70ba-913e-e733a480e12c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alleghenycounty.us/Parks-and-Events/Parks/South-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=221460103181055332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-park",
      "poi_latitude": "40.3050315",
      "poi_longitude": "-79.9958479",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 412-350-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e04a-74d9-b464-629991932b71",
        "storage_key": "property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT4msLuv5NIgRZDUHXsrIEgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_81b07398-907d-4c1e-9dc6-c382b12acc86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "South Park Children's Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2406-2498 Brownsville Rd, South Park Township, PA 15129, USA",
      "poi_short_description": "Public, fenced playground offering swings, slides, and a zip line.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-ad08-708b-8aee-88b55664c916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-ad08-708b-8aee-88b55664c916",
        "storage_key": "property/6767906449166347/019fce0b-ad08-708b-8aee-88b55664c916.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.southparktwp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10422943687131581650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-park-childrens-playground",
      "poi_latitude": "40.3074326",
      "poi_longitude": "-79.99661669999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwYwIUMP7NIgR0sxgcQ-8pZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3ff19286-5f81-443f-a53e-8671973285f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Pittsburgh Botanic Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "CR8H+V7, 799 Pinkerton Run Rd, Oakdale, PA 15071, USA",
      "poi_short_description": "Themed gardens, a dogwood meadow & woodlands with a lotus pond, laced with walking trails.",
      "poi_long_description": "Themed gardens, a dogwood meadow & woodlands with a lotus pond, laced with walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-ae68-7682-9f9d-205932a7ebdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-ae68-7682-9f9d-205932a7ebdc",
        "storage_key": "property/6767906449166347/019fce0b-ae68-7682-9f9d-205932a7ebdc.webp",
        "width": 1280,
        "height": 811
      },
      "poi_business_url": "https://pittsburghbotanicgarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10214162727047615722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pittsburgh-botanic-garden",
      "poi_latitude": "40.4174744",
      "poi_longitude": "-80.1719597",
      "poi_miles_from_property": "14.7 mi",
      "poi_walking_minutes": "5 hours 38 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 412-444-4464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e04a-74d9-b464-629991932b71",
        "storage_key": "property/6767906449166347/019d026b-e04a-74d9-b464-629991932b71.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuXiabp5ZNIgR6lS1H-L-v40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1fb18858-d9f7-4204-9bfa-b6ef56887c11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Pleasant Kingdom Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "218 Winifred Dr, Pittsburgh, PA 15236, USA",
      "poi_short_description": "Wooded play area with a variety of equipment including slides, plus picnic areas, and tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-afe2-73ff-8f6b-7aed3056ef3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-afe2-73ff-8f6b-7aed3056ef3d",
        "storage_key": "property/6767906449166347/019fce0b-afe2-73ff-8f6b-7aed3056ef3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15058855887603370981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pleasant-kingdom-playground",
      "poi_latitude": "40.3300099",
      "poi_longitude": "-79.9533137",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCUe93h37NIgR5QtmAKXN-9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_20cf8e9d-9723-42d1-a96e-c93ca1c9a5bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Washington Junction",
      "poi_type": "Transportation & Transit",
      "poi_address": "Bethel Park, PA 15102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-b33d-70a6-a7ff-2fa6d07e5070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-b33d-70a6-a7ff-2fa6d07e5070",
        "storage_key": "property/6767906449166347/019fce0b-b33d-70a6-a7ff-2fa6d07e5070.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.portauthority.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127534849076191533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-junction",
      "poi_latitude": "40.3535665",
      "poi_longitude": "-80.028007",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 412-442-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdFC_Oj5NIgRLWG_f2RfLrY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ebf75bba-cab4-4e1d-9a29-8c09d30371c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "South Hills Village",
      "poi_type": "Transportation & Transit",
      "poi_address": "Fort Couch Rd, Pittsburgh, PA 15241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-b434-749c-a250-2d8b1384bc68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-b434-749c-a250-2d8b1384bc68",
        "storage_key": "property/6767906449166347/019fce0b-b434-749c-a250-2d8b1384bc68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portauthority.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2779040557791113727&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-hills-village",
      "poi_latitude": "40.3393909",
      "poi_longitude": "-80.0532731",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjfJnybL5NIgR__GKz6kikSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_086918a5-09eb-4794-8f70-b1be1a806a9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Castle Shannon Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Castle Shannon, PA 15234, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-b5d6-7080-b058-5f499d8dda3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-b5d6-7080-b058-5f499d8dda3c",
        "storage_key": "property/6767906449166347/019fce0b-b5d6-7080-b058-5f499d8dda3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15689047791981505364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "castle-shannon-station",
      "poi_latitude": "40.368163",
      "poi_longitude": "-80.030239",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq8kMz1_3NIgRVCsvudexutk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c15fceb4-2a2e-4fc2-9150-8bfa08ec6d10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Memorial Hall",
      "poi_type": "Transportation & Transit",
      "poi_address": "Castle Shannon, PA 15234, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-b736-70bf-8b18-109ac1a2ca10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-b736-70bf-8b18-109ac1a2ca10",
        "storage_key": "property/6767906449166347/019fce0b-b736-70bf-8b18-109ac1a2ca10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14079850288788195155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hall",
      "poi_latitude": "40.3664948",
      "poi_longitude": "-80.0164203",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-dAgQVb3NIgRU8fmST2tZcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6eef176b-5d7d-4dad-83c9-3dcca7811afb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Bethel Village",
      "poi_type": "Transportation & Transit",
      "poi_address": "Bethel Park, PA 15102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-ba63-755f-a1a8-43fe81c305d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-ba63-755f-a1a8-43fe81c305d1",
        "storage_key": "property/6767906449166347/019fce0b-ba63-755f-a1a8-43fe81c305d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portauthority.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14061805797621981729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bethel-village",
      "poi_latitude": "40.3443695",
      "poi_longitude": "-80.0462402",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 412-442-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zLr9rb5NIgRIWLJy96RJcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4539254d-f561-4691-8b44-535403e268e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "South Hills Junction",
      "poi_type": "Transportation & Transit",
      "poi_address": "Pittsburgh, PA 15210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-bb1a-740e-a49e-9ed7b42cd5e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-bb1a-740e-a49e-9ed7b42cd5e9",
        "storage_key": "property/6767906449166347/019fce0b-bb1a-740e-a49e-9ed7b42cd5e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.habertuar.com/gundem/south-hills-junction-136772",
      "poi_directions_map_url": "https://maps.google.com/?cid=16010517902324265062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-hills-junction",
      "poi_latitude": "40.4208277",
      "poi_longitude": "-80.0072026",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl9zJrzTxNIgRZvARbjTJMN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9962d324-dc40-491b-b6ea-8661f7b2f7c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Pittsburgh International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1000 Airport Blvd, Pittsburgh, PA 15231, USA",
      "poi_short_description": "Airport featuring free WiFi plus art exhibits & a huge model of a Tyrannosaurus rex.",
      "poi_long_description": "Airport featuring free WiFi plus art exhibits & a huge model of a Tyrannosaurus rex.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-bcb7-76ec-82ac-781d55aa5889.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-bcb7-76ec-82ac-781d55aa5889",
        "storage_key": "property/6767906449166347/019fce0b-bcb7-76ec-82ac-781d55aa5889.webp",
        "width": 1200,
        "height": 850
      },
      "poi_business_url": "https://flypittsburgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14416628294299238233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pittsburgh-international-airport",
      "poi_latitude": "40.4957262",
      "poi_longitude": "-80.2473255",
      "poi_miles_from_property": "26.5 mi",
      "poi_walking_minutes": "10 hours 2 mins",
      "poi_biking_minutes": "3 hours 37 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 412-472-3525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e55b-73fe-ad4f-dc26581c02b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e55b-73fe-ad4f-dc26581c02b3",
        "storage_key": "property/6767906449166347/019d026b-e55b-73fe-ad4f-dc26581c02b3.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1vNTsNcNIgRWT-NFA0nEsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c3fee815-6589-4c5f-b36a-1c396d378e49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "UPMC Outpatient Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "275 Clairton Blvd, West Mifflin, PA 15236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-be76-7549-bb71-c0af5af20735.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-be76-7549-bb71-c0af5af20735",
        "storage_key": "property/6767906449166347/019fce0b-be76-7549-bb71-c0af5af20735.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.upmc.com/locations/outpatient/southwest-pa/west-mifflin/clairton-blvd?utm_source=google&utm_medium=organic&utm_campaign=business-profile&utm_content=outpatient-center-swpa-upmc-outpatient-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=13785111095786742708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upmc-outpatient-center",
      "poi_latitude": "40.3378179",
      "poi_longitude": "-79.9491735",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-650-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e521-7249-8492-0314b6247c2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e521-7249-8492-0314b6247c2f",
        "storage_key": "property/6767906449166347/019d026b-e521-7249-8492-0314b6247c2f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsZWyz5n7NIgRtCOqRYGNTr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_447ff2d5-d822-4104-8fc8-241a488864d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Jefferson Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "565 Coal Valley Rd, Jefferson Hills, PA 15025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-c14a-72fa-81a5-7fd57aa67cf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-c14a-72fa-81a5-7fd57aa67cf2",
        "storage_key": "property/6767906449166347/019fce0b-c14a-72fa-81a5-7fd57aa67cf2.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "https://www.ahn.org/locations/hospitals/jefferson",
      "poi_directions_map_url": "https://maps.google.com/?cid=14131128249769492210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-hospital",
      "poi_latitude": "40.3173745",
      "poi_longitude": "-79.93342489999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 412-469-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e521-7249-8492-0314b6247c2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e521-7249-8492-0314b6247c2f",
        "storage_key": "property/6767906449166347/019d026b-e521-7249-8492-0314b6247c2f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJuSM1gNj6NIgR8n7_8kXaG8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a3652864-27fb-4617-9e5f-2a1ab254d94c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "UPMC Rehabilitation Institute",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1300 Oxford Dr Suite 1400, Bethel Park, PA 15102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-c2eb-704d-a9e8-80acc0aa8c7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-c2eb-704d-a9e8-80acc0aa8c7e",
        "storage_key": "property/6767906449166347/019fce0b-c2eb-704d-a9e8-80acc0aa8c7e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.upmc.com/services/rehab/crs/locations/allegheny-county#bethel?utm_source=google&utm_medium=organic&utm_campaign=business-profile&utm_content=rehabilitation-insitute-swpa-upmc-rehabilitation-institute",
      "poi_directions_map_url": "https://maps.google.com/?cid=12939132571830161242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upmc-rehabilitation-institute",
      "poi_latitude": "40.3429735",
      "poi_longitude": "-80.0484804",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-851-8850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcb8hBbT5NIgRWo-fBYUIkbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fe398a71-0127-4788-968b-15837efeb9e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "UPMC Mercy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1400 Locust St, Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-c320-704d-9d45-c546967d6f60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-c320-704d-9d45-c546967d6f60",
        "storage_key": "property/6767906449166347/019fce0b-c320-704d-9d45-c546967d6f60.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.upmc.com/locations/hospitals/mercy?utm_source=google&utm_medium=organic&utm_campaign=business-profile&utm_content=hospital-swpa-upmc-mercy",
      "poi_directions_map_url": "https://maps.google.com/?cid=8244303519153733630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upmc-mercy",
      "poi_latitude": "40.4364439",
      "poi_longitude": "-79.985575",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 412-232-8111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e521-7249-8492-0314b6247c2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e521-7249-8492-0314b6247c2f",
        "storage_key": "property/6767906449166347/019d026b-e521-7249-8492-0314b6247c2f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsesVYGfxNIgR_j-p116maXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c66a2358-0e31-4ecf-a377-b8f31be145c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Cathedral of Learning",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4200 Fifth Ave, Pittsburgh, PA 15260, USA",
      "poi_short_description": "This iconic 42-story building at the University of Pittsburgh was commissioned in 1921.",
      "poi_long_description": "This iconic 42-story building at the University of Pittsburgh was commissioned in 1921.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-c570-73c9-9b49-06a7d176f51b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-c570-73c9-9b49-06a7d176f51b",
        "storage_key": "property/6767906449166347/019fce0b-c570-73c9-9b49-06a7d176f51b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tour.pitt.edu/tour/cathedral-learning",
      "poi_directions_map_url": "https://maps.google.com/?cid=14670925009112268710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cathedral-of-learning",
      "poi_latitude": "40.4443625",
      "poi_longitude": "-79.95315509999999",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 412-624-4141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJixzjoyjyNIgRpv-H3pCYmcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_71685850-bf6f-4eb2-88f8-61ea82c6c9f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Carnegie Mellon University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5000 Forbes Ave, Pittsburgh, PA 15213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-c7f9-71fc-9f01-77ea6dc828f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-c7f9-71fc-9f01-77ea6dc828f0",
        "storage_key": "property/6767906449166347/019fce0b-c7f9-71fc-9f01-77ea6dc828f0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://cmu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9831757410451380980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carnegie-mellon-university",
      "poi_latitude": "40.4432027",
      "poi_longitude": "-79.9428499",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 412-268-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-dc6a-701f-8fd7-04378f7b1892",
        "storage_key": "property/6767906449166347/019d026b-dc6a-701f-8fd7-04378f7b1892.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn5pnWB_yNIgR9NrEH0ZrcYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_685e96e1-a74b-4453-b13f-d7aab75f55c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "The Tower at PNC Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 Fifth Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-ca59-775a-be2e-e3b834fa4396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-ca59-775a-be2e-e3b834fa4396",
        "storage_key": "property/6767906449166347/019fce0b-ca59-775a-be2e-e3b834fa4396.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pnc.com/en/about-pnc.html?lnksrc=corp-listing-google",
      "poi_directions_map_url": "https://maps.google.com/?cid=15727335626315097830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-tower-at-pnc-plaza",
      "poi_latitude": "40.440529",
      "poi_longitude": "-80.000289",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 888-762-2265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-TEyIVfxNIgR5mbb1Wy4Qto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f0bbf00f-0594-49fa-a4af-a69242b23565",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "Highmark Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "120 Fifth Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-c9b6-70bd-9922-49766bd7323c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-c9b6-70bd-9922-49766bd7323c",
        "storage_key": "property/6767906449166347/019fce0b-c9b6-70bd-9922-49766bd7323c.webp",
        "width": 1265,
        "height": 949
      },
      "poi_business_url": "https://www.highmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15507996705669340876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highmark-corporate-headquarters",
      "poi_latitude": "40.4419235",
      "poi_longitude": "-80.00317319999999",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 412-544-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZ51f1bxNIgRzF5Zw9Z4N9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cd1a690b-9af1-4e06-9026-cf6c3afc9b89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "U. S. Steel Research and Technology Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "800 E Waterfront Dr, Munhall, PA 15120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-ccbb-724b-a726-c8899161d0b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-ccbb-724b-a726-c8899161d0b4",
        "storage_key": "property/6767906449166347/019fce0b-ccbb-724b-a726-c8899161d0b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ussteel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12825788556694023398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "u-s-steel-research-and-technology-center",
      "poi_latitude": "40.4125767",
      "poi_longitude": "-79.8984638",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 412-433-2788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCc8IEz_uNIgR5mwEBr1a_rE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f55b6036-0722-4a78-ac76-c11cb6a19d81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "poi_name": "United States Steel Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 Grant St, Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-d000-77d3-b5c1-c6c1816d3e14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0b-d000-77d3-b5c1-c6c1816d3e14",
        "storage_key": "property/6767906449166347/019fce0b-d000-77d3-b5c1-c6c1816d3e14.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.ussteel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4432688808963528601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-steel-corporation",
      "poi_latitude": "40.44156",
      "poi_longitude": "-79.9948622",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 412-433-1121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-e055-71cf-af1f-c753fa82764b",
        "storage_key": "property/6767906449166347/019d026b-e055-71cf-af1f-c753fa82764b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8UrGOHzNIgRmdcegvwShD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_c80104ab-11e7-4cf6-802f-27e7a9d15133",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ebbe6072-002d-4fcd-b78b-8c2a7367c624",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7ca24a2f-26f4-45c6-85ff-dad7fdf1738c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2e74118c-e618-47f2-ada6-6d0fdec939ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c7824f3b-dc5d-46a8-b727-fabe2c3dde2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e0c50e98-19ca-47a4-8304-131dd98e6ce2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_2249e76b37d4b170a1cb8715",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "rating": "5",
      "name": "Dianne Thomas",
      "text": "I just wanna say everytime I come into the office all them leasing associates are very nice and sweet. I’m reading these reviews and in my 2 years of living here I ain’t ever see a dang roach in my house. These infestations are brought in by tenants who were infested before and they are looking for a place to blame.",
      "date": "2025-11-15",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a00a3246-d52d-4677-b1a5-55a2c062ffee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-1876-71e9-bf39-95346bb16ef6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with sofa, coffee table, TV, and a doorway to another room.",
        "public_id": "019d026d-1876-71e9-bf39-95346bb16ef6",
        "storage_key": "property/6767906449166347/019d026d-1876-71e9-bf39-95346bb16ef6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 532 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BsYBrg3fWH1"
    },
    {
      "id": "custom_3e7d62cb-3657-400d-9b1c-4c8cea9bc160",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-1876-71e9-bf39-92e61d5f5251.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Cozy living room with a sofa, armchair, and decorative mirrors.",
        "public_id": "019d026d-1876-71e9-bf39-92e61d5f5251",
        "storage_key": "property/6767906449166347/019d026d-1876-71e9-bf39-92e61d5f5251.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 684 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=fSJ4P92Qb1e"
    },
    {
      "id": "custom_25b92a47-743c-4b88-b2e6-1ea9cd96dc1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-18b8-70fc-8446-0184e3f21860.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and dining area with a couch, chairs, table, and wall art.",
        "public_id": "019d026d-18b8-70fc-8446-0184e3f21860",
        "storage_key": "property/6767906449166347/019d026d-18b8-70fc-8446-0184e3f21860.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 684 SF (Premium)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=idCzfNwtxdM"
    },
    {
      "id": "custom_d8ac715b-a02a-476d-8288-e3c60e1b6911",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026c-755d-72ef-9a41-767654539a67.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a sofa, coffee table, chairs, and a window.",
        "public_id": "019d026c-755d-72ef-9a41-767654539a67",
        "storage_key": "property/6767906449166347/019d026c-755d-72ef-9a41-767654539a67.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "3BR,1BA - 763 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oWenPrCg1R9"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1328-83be-706f-a03b-2ce57cdbc796",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-the-alden-south-hills-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347"
    },
    {
      "lead_collector_id": "019c3043-a30d-70c9-a68a-639db95e5a66",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-alden",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347"
    },
    {
      "lead_collector_id": "019c3043-a381-72ea-a519-ac033086068d",
      "lead_source": "LANDING_PAGE",
      "name": "the-alden",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-pittsburgh-pa-alden-south-hills-924",
      "search_query": "pet friendly apartments Pittsburgh PA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Pittsburgh, PA",
      "h2_subtitle": "Discover pet friendly apartments in Pittsburgh, PA at The Alden South Hills. Embrace a community that welcomes every family member, including furry ones.",
      "page_copy": "Welcome to The Alden South Hills, where pets are part of the family. Located in the heart of Pittsburgh, PA, our pet friendly apartments offer a great living environment for you and your four-legged companions. Our thoughtfully designed community boasts a dedicated dog park, allowing your pets ample space to roam and play. Beyond pet amenities, you'll enjoy features such as a fitness center and resident lounge.\n\nNestled in the Pleasant Hills neighborhood, The Alden South Hills offers easy access to the vibrant city life of Pittsburgh while ensuring a serene living atmosphere. With cozy studios to expansive three-bedroom layouts, our apartments provide a perfect fit for every household. Schedule a visit today and see why our pet-friendly community is Pittsburgh's top choice!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Pittsburgh, PA",
      "seo_description": "Explore pet friendly apartments in Pittsburgh, PA at The Alden South Hills, featuring a dog park and spacious layouts. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "apartments-with-pool-pleasant-hills-alden-south-8",
      "search_query": "apartments with a pool in Pleasant Hills",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Pleasant Hills",
      "h2_subtitle": "Enjoy the luxury of apartments with a pool in Pleasant Hills at The Alden South Hills. Dive into relaxation just steps from your door.",
      "page_copy": "At The Alden South Hills, experience the best of apartment living in Pleasant Hills. Our community features a refreshing swimming pool, perfect for unwinding after a long day or enjoying sunny weekends. Our resort-style amenities, including a fitness center and resident lounge, enhance the vibrant lifestyle we offer.\n\nLocated in the charming Pleasant Hills neighborhood, The Alden South Hills provides a serene living environment with easy access to Pittsburgh's dynamic cultural scene. From cozy studios to spacious three-bedroom options, our apartments cater to all living preferences. Discover a place where comfort meets luxury, complete with a pool that's the cherry on top. Schedule a tour today and dive into a lifestyle of convenience and leisure!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Pleasant Hills",
      "seo_description": "Discover apartments with a pool in Pleasant Hills at The Alden South Hills. Enjoy resort-style amenities and vibrant living spaces. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "dog-park-apartments-allegheny-county-alden-south-hills-506",
      "search_query": "dog park apartments Allegheny County",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Allegheny County",
      "h2_subtitle": "Explore dog park apartments in Allegheny County at The Alden South Hills. Ideal for pet lovers seeking a community with dedicated pet amenities.",
      "page_copy": "Discover the ideal pet-friendly haven at The Alden South Hills, your next home in Allegheny County offering exclusive access to a well-maintained dog park. Perfect for pet owners, our community blends comfort with practicality, providing a space where you and your furry friends can thrive. Beyond pet amenities, residents enjoy a host of other features, including a fitness center and resident lounge, creating an engaging living experience.\n\nSituated in the Pleasant Hills area, The Alden South Hills stands as a prime location with easy access to the exciting lifestyle Pittsburgh has to offer. With a variety of floor plans from studios to three-bedroom units, we cater to a wide range of lifestyles. Join a welcoming community that understands and values the companionship of pets. Schedule a visit today and see what sets us apart in Allegheny County!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Allegheny County",
      "seo_description": "Find dog park apartments in Allegheny County at The Alden South Hills. Pet-friendly community with exclusive amenities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-pittsburgh-alden-south-hills-563",
      "search_query": "fitness center apartments in Pittsburgh",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Pittsburgh",
      "h2_subtitle": "Discover fitness center apartments in Pittsburgh at The Alden South Hills. Elevate your lifestyle with our wellness-focused amenities.",
      "page_copy": "Elevate your lifestyle with a home at The Alden South Hills, where our premier apartments in Pittsburgh feature a state-of-the-art fitness center. Perfect for those prioritizing health and wellness, our fitness center offers residents the convenience of staying active without leaving the comfort of their community. Coupled with other fantastic amenities like a swimming pool and resident lounge, we cater to a balanced lifestyle.\n\nLocated in the sought-after Pleasant Hills neighborhood, The Alden South Hills provides both tranquility and easy access to Pittsburgh's vibrant cultural and social hubs. Whether you choose a studio, a spacious three-bedroom, or something in between, our floor plans are designed with you in mind. Immerse yourself in a community that supports your well-being—schedule a tour today and take the first step towards a healthier life in Allegheny County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Pittsburgh",
      "seo_description": "Discover fitness center apartments in Pittsburgh at The Alden South Hills. Enjoy exclusive wellness amenities in a vibrant community. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "dedicated-parking-apartments-15236-alden-south-hills-447",
      "search_query": "dedicated parking apartments 15236",
      "category": "Amenity",
      "h1_title": "Dedicated Parking Apartments in 15236",
      "h2_subtitle": "Find dedicated parking apartments in 15236 at The Alden South Hills. Enjoy hassle-free parking in our Pleasant Hills community.",
      "page_copy": "Experience the convenience of dedicated parking at The Alden South Hills, located in the 15236 area. Our apartments offer the luxury of reserved parking spaces, ensuring that your arrival home is always stress-free. Alongside this practical benefit, residents can enjoy an array of community amenities including a swimming pool, pet-friendly dog park, and resident lounge.\n\nNestled in the Pleasant Hills neighborhood, The Alden South Hills provides a peaceful retreat while being just minutes away from the vibrant energy of Pittsburgh. Choose from a variety of floor plans, meeting the needs of individuals, couples, and families. Our commitment to providing dedicated parking is just one way we strive to enhance your living experience. Schedule a visit to see how seamless your life can be with us!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dedicated Parking Apartments in 15236",
      "seo_description": "Discover dedicated parking apartments in the 15236 area at The Alden South Hills. Enjoy our amenity-rich community. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "studio-apartments-pleasant-hills-pa-alden-south-hills-533",
      "search_query": "studio apartments in Pleasant Hills PA",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Pleasant Hills, PA",
      "h2_subtitle": "Discover modern studio apartments in Pleasant Hills, PA at The Alden South Hills. Ideal for individuals seeking convenience and comfort.",
      "page_copy": "Embrace simplicity and style in the studio apartments at The Alden South Hills, nestled in the heart of Pleasant Hills, PA. These modern studios offer the perfect blend of coziness and functionality, making them ideal for individuals seeking a streamlined lifestyle without sacrificing comfort. Residents enjoy access to a wealth of amenities, including a fitness center, inviting swimming pool, and vibrant resident lounge.\n\nLocated in the charming neighborhood of Pleasant Hills, our community offers easy access to Pittsburgh while maintaining a serene, suburban atmosphere. The Alden South Hills provides a welcoming environment for residents, fostering a sense of community with exclusive activities and a pet-friendly policy. Discover the advantage of studio living in Pleasant Hills, PA, by scheduling a tour today and envisioning your new lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Pleasant Hills, PA",
      "seo_description": "Find modern studio apartments in Pleasant Hills, PA at The Alden South Hills. Enjoy a cozy lifestyle with top amenities. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-pittsburgh-pa-alden-south-hills-633",
      "search_query": "one bedroom apartments Pittsburgh PA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Pittsburgh, PA",
      "h2_subtitle": "Explore one bedroom apartments in Pittsburgh, PA at The Alden South Hills. Perfect for those seeking comfort and convenience in Allegheny County.",
      "page_copy": "Discover the perfect one bedroom apartments at The Alden South Hills in Pittsburgh, PA, where modern living meets unparalleled comfort. These thoughtfully designed spaces offer an ideal retreat for those looking to enjoy a balance of style and functionality. Residents have access to a variety of amenities, including a fitness center, a refreshing swimming pool, and communal grilling stations.\n\nSituated in the peaceful Pleasant Hills neighborhood, our one bedroom apartments provide the perfect blend of suburban tranquility and easy access to the vibrant city life of Pittsburgh. With added features like pet-friendly policies and resident activities, The Alden South Hills ensures a welcoming atmosphere for everyone. Begin your journey towards a new home in our community—schedule a tour today and step into ideal living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Pittsburgh, PA",
      "seo_description": "Explore one bedroom apartments in Pittsburgh, PA at The Alden South Hills. Enjoy comfort with top amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-allegheny-county-alden-south-hills-214",
      "search_query": "two bedroom apartments near Allegheny County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Allegheny County",
      "h2_subtitle": "Discover two bedroom apartments near Allegheny County at The Alden South Hills. Ideal for families or roommates seeking spacious living.",
      "page_copy": "At The Alden South Hills, find the ideal two bedroom apartments situated near Allegheny County, offering the perfect living arrangement for families or roommates desiring extra space. Enjoy modern amenities such as a state-of-the-art fitness center, a sparkling swimming pool, and ample grilling stations that enhance lifestyle choices.\n\nOur prime location in Pleasant Hills provides a serene suburban atmosphere, while maintaining close proximity to the bustling city life of Pittsburgh. Each two bedroom apartment is designed with both comfort and practicality in mind, featuring open floor plans and ample storage solutions. Experience the best of both worlds, with community activities and a pet-friendly environment, making The Alden South Hills a perfect place to call home. Visit us today to explore your future residence!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Allegheny County",
      "seo_description": "Explore two bedroom apartments near Allegheny County at The Alden South Hills. Spacious living with great amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-15236-alden-south-hills-908",
      "search_query": "three bedroom apartments 15236",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in 15236",
      "h2_subtitle": "Explore three bedroom apartments in the 15236 area at The Alden South Hills. Perfect for families needing ample space and modern amenities.",
      "page_copy": "Discover spacious three bedroom apartments in the 15236 area at The Alden South Hills. Our community offers the ideal setting for families seeking expansive living areas paired with modern conveniences. Each apartment is thoughtfully designed to provide a harmonious balance of style and function, catering to those who need extra room.\n\nSituated in Pleasant Hills, our community is a haven of comfort with access to amenities like a refreshing swimming pool, fitness center, and vibrant resident lounge. The Alden South Hills provides a welcoming environment, complete with a pet-friendly policy and numerous resident activities. Experience the best of suburbia with quick access to Pittsburgh’s city life. To see how our three bedroom apartments can suit your lifestyle, schedule a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in 15236",
      "seo_description": "Find three bedroom apartments in the 15236 area at The Alden South Hills. Spacious and modern living perfect for families. Visit us now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "apartments-near-mcannulty-elementary-school-alden-south-hills-948",
      "search_query": "apartments near McAnnulty Elementary School Pittsburgh",
      "category": "School",
      "h1_title": "Apartments Near McAnnulty Elementary School",
      "h2_subtitle": "Find ideal apartments near McAnnulty Elementary School at The Alden South Hills. A perfect choice for families in Pittsburgh seeking convenience and quality education.",
      "page_copy": "Searching for apartments near McAnnulty Elementary School in Pittsburgh? Consider The Alden South Hills, offering a convenient location within easy reach of quality education. Ideal for families, our community provides spacious floor plans from studios to three-bedroom apartments, all designed with comfort in mind.\n\nLocated in the Pleasant Hills area, The Alden South Hills is more than just a place to live; it’s a community with a range of amenities including a swimming pool, fitness center, and pet-friendly spots. With easy access to local schools and vibrant Pittsburgh highlights, our property is suited for those looking for a nurturing environment for their children while enjoying the benefits of suburban living. Schedule a tour today to explore what could be your next home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McAnnulty Elementary School",
      "seo_description": "Discover The Alden South Hills, offering apartments near McAnnulty Elementary School, Pittsburgh. Perfect for families seeking quality living and education.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "the-alden-south-hills-near-je-harrison-education-center-693",
      "search_query": "The Alden South Hills close to J.E. Harrison Education Center",
      "category": "School",
      "h1_title": "The Alden South Hills Near J.E. Harrison",
      "h2_subtitle": "Explore The Alden South Hills, conveniently located close to J.E. Harrison Education Center. A great choice for families prioritizing education.",
      "page_copy": "The Alden South Hills is ideally situated close to J.E. Harrison Education Center, making it an excellent option for families valuing proximity to great schools. Our community offers a variety of floor plans, whether you're interested in a cozy studio or a spacious three-bedroom layout, all crafted to suit diverse lifestyles.\n\nNestled in Pleasant Hills, residents enjoy a host of amenities designed for convenience and leisure, such as a modern fitness center, a shimmering swimming pool, and pet-friendly facilities. The location allows families to benefit from a serene suburban atmosphere while remaining close to educational opportunities and the vibrant city life in Pittsburgh. Ready to discover more about living at The Alden South Hills? Contact us today to schedule a tour!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Alden South Hills Near J.E. Harrison",
      "seo_description": "Discover family-friendly living at The Alden South Hills near J.E. Harrison Education Center, offering spacious apartments and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "apartments-by-baldwin-high-school-15236-alden-south-hills-590",
      "search_query": "apartments by Baldwin High School 15236",
      "category": "School",
      "h1_title": "Apartments by Baldwin High School, 15236",
      "h2_subtitle": "Discover convenient apartments by Baldwin High School at The Alden South Hills. Perfect for families in the 15236 area seeking quality education nearby.",
      "page_copy": "Explore The Alden South Hills, offering ideal apartments close to Baldwin High School in the 15236 area. Our community provides a convenient option for families seeking proximity to quality education facilities. Choose from a range of floor plans, including cozy studios and spacious three-bedroom units, each designed to cater to various preferences and needs.\n\nLocated in Pleasant Hills, residents enjoy a wide array of amenities such as a fitness center, swimming pool, and pet-friendly spaces. The Alden South Hills offers a serene suburban setting while granting easy access to Pittsburgh’s vibrant downtown attractions. Experience the blend of convenience and comfort by scheduling a tour of our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Baldwin High School, 15236",
      "seo_description": "Find ideal living at The Alden South Hills with apartments near Baldwin High School in 15236. Enjoy a great community with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "pleasant-hills-apartments-near-whitehall-elementary-alden-south-hills-139",
      "search_query": "Pleasant Hills apartments near Whitehall Elementary School",
      "category": "School",
      "h1_title": "Pleasant Hills Apartments Near Whitehall Elementary",
      "h2_subtitle": "Choose Pleasant Hills apartments near Whitehall Elementary School at The Alden South Hills. Ideal for families seeking a supportive community near schools.",
      "page_copy": "For families looking for Pleasant Hills apartments near Whitehall Elementary School, The Alden South Hills provides a perfect solution. Our community offers diverse living spaces, from studios to spacious three-bedroom layouts, ensuring each family finds its ideal home in a nurturing environment.\n\nThe Alden South Hills in Pleasant Hills offers residents a host of amenities such as a refreshing swimming pool, a resident lounge, and pet-friendly areas, contributing to an engaged and vibrant community atmosphere. With our strategic location, families benefit from being near top educational facilities while enjoying the tranquility of suburban living. For more information or to schedule a tour, reach out to us today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pleasant Hills Apartments Near Whitehall Elementary",
      "seo_description": "Discover family-friendly living at The Alden South Hills with Pleasant Hills apartments near Whitehall Elementary School and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "apartments-near-st-clair-hospital-pittsburgh-alden-south-hills-907",
      "search_query": "apartments near St. Clair Hospital Pittsburgh",
      "category": "Hospital",
      "h1_title": "Convenient Apartments Near St. Clair Hospital",
      "h2_subtitle": "Find convenient apartments near St. Clair Hospital in Pittsburgh at The Alden South Hills. Ideal for healthcare professionals seeking comfort and ease.",
      "page_copy": "Located just a short drive from St. Clair Hospital, The Alden South Hills provides convenient apartment living in the bustling city of Pittsburgh. Our diverse floor plans, from intimate studios to expansive three-bedroom units, cater to individuals and families seeking a home close to this key healthcare facility.\n\nExperience the remarkable amenities at The Alden South Hills, such as a refreshing swimming pool, modern fitness center, and a welcoming resident lounge. Situated in the inviting Pleasant Hills neighborhood, our community is perfect for healthcare professionals and hospital staff looking to minimize their commute while enjoying a vibrant lifestyle. Explore our community and discover your next home by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Clair Hospital, Pittsburgh",
      "seo_description": "Explore The Alden South Hills for apartments near St. Clair Hospital, Pittsburgh. Offering comfort and convenience for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "apartments-close-to-upmc-outpatient-center-alden-south-hills-585",
      "search_query": "apartments close to UPMC Outpatient Center Allegheny County",
      "category": "Hospital",
      "h1_title": "Apartments Near UPMC Outpatient Center",
      "h2_subtitle": "Discover apartments close to UPMC Outpatient Center in Allegheny County at The Alden South Hills. Ideal for professionals seeking nearby, quality living options.",
      "page_copy": "The Alden South Hills presents ideal apartment living close to the UPMC Outpatient Center in Allegheny County. Our community offers varied floor plans, including studios and three-bedroom options, perfect for medical professionals and staff seeking nearby accommodation.\n\nResiding in Pleasant Hills, Pittsburgh, you'll appreciate amenities like pet-friendly areas, a modern fitness center, and relaxing resident lounges. These benefits complement the lifestyle of working professionals who need a restful, yet engaging home environment. Known for its proximity to healthcare and urban conveniences, The Alden South Hills is the perfect blend of professional convenience and exceptional living. Schedule a visit to experience firsthand the multifaceted lifestyle we offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Near UPMC Outpatient Center Apartments",
      "seo_description": "Live close to the UPMC Outpatient Center at The Alden South Hills. Offering quality living options perfect for Allegheny County professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "apartments-near-miners-memorial-park-pittsburgh-alden-south-hills-145",
      "search_query": "apartments near Miner's Memorial Park Pittsburgh",
      "category": "Park",
      "h1_title": "Apartments Near Miner's Memorial Park",
      "h2_subtitle": "Explore The Alden South Hills, featuring apartments near Miner's Memorial Park in Pittsburgh. Perfect for those who love the outdoors and convenient living.",
      "page_copy": "The Alden South Hills offers conveniently located apartments near Miner's Memorial Park in Pittsburgh, ideal for nature enthusiasts and those who appreciate green spaces. Choose from our selection of floor plans, including studios and three-bedroom units, designed to fit a variety of lifestyles.\n\nNestled in the Pleasant Hills neighborhood, residents at The Alden South Hills enjoy an abundance of amenities, such as a pet-friendly dog park, fitness center, and inviting resident lounge. With Miner's Memorial Park just a short distance away, you can enjoy the beauty of nature and outdoor activities in close proximity. Discover the perfect blend of comfort and nature by scheduling a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Miner's Memorial Park",
      "seo_description": "Find your new home close to Miner's Memorial Park at The Alden South Hills, offering nature-friendly living in Pittsburgh.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "apartments-close-to-millennium-park-pleasant-hills-alden-south-hills-648",
      "search_query": "apartments close to Millennium Park Pleasant Hills",
      "category": "Park",
      "h1_title": "Apartments Close to Millennium Park",
      "h2_subtitle": "Experience life at The Alden South Hills with apartments just steps away from Millennium Park in Pleasant Hills, perfect for nature lovers and families.",
      "page_copy": "Discover the ideal blend of comfort and convenience at The Alden South Hills, offering apartments close to the vibrant Millennium Park in Pleasant Hills. Whether you’re looking for a cozy studio or a spacious three-bedroom, our community provides diverse living options to suit your needs.\n\nEmbrace a lifestyle surrounded by exceptional amenities like grilling stations, a resident lounge, and pet-friendly areas. Just a stone's throw from Millennium Park, you can enjoy leisurely strolls, picnics, and outdoor activities easily accessible from your doorstep. Explore how The Alden South Hills can be your next home by booking a tour today, where community spirit and nature come together.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millennium Park Nearby Apartments",
      "seo_description": "Live near Millennium Park at The Alden South Hills in Pleasant Hills, featuring appealing amenities for a balanced, active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "apartments-near-washington-junction-alden-south-hills-267",
      "search_query": "apartments near washington junction allegheny county",
      "category": "Transit",
      "h1_title": "Apartments Near Washington Junction",
      "h2_subtitle": "Explore The Alden South Hills, featuring nearby apartments to Washington Junction in Allegheny County, offering convenience and comfort.",
      "page_copy": "Discover The Alden South Hills, offering spacious and modern apartments near Washington Junction in Allegheny County. Our community features a variety of floor plans, including cozy studios and expansive three-bedroom units, designed to suit diverse lifestyles.\n\nSituated in the Pleasant Hills neighborhood, residents enjoy amenities such as a fitness center, dog park, and resident lounge, perfect for relaxation and community engagement. Proximity to Washington Junction provides convenient access to public transportation, making commutes simple and efficient. Experience the ideal mix of suburban tranquility and urban convenience by choosing The Alden South Hills as your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washington Junction Nearby Apartments",
      "seo_description": "Find apartments near Washington Junction at The Alden South Hills, merging comfort and accessibility in Allegheny County.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "alden-south-hills-near-south-hills-village-station-255",
      "search_query": "the alden south hills close to south hills village station",
      "category": "Transit",
      "h1_title": "The Alden Close to South Hills Village",
      "h2_subtitle": "The Alden South Hills offers unparalleled apartment living close to South Hills Village Station, combining comfort with commuting convenience.",
      "page_copy": "Welcome to The Alden South Hills, offering exceptional apartment living located conveniently close to South Hills Village Station. Our diverse selection of floor plans, from cozy studios to expansive three-bedroom apartments, caters to a variety of living preferences.\n\nNestled in the Pleasant Hills area, residents at The Alden South Hills enjoy a host of amenities, including a modern fitness center, pet-friendly dog park, and vibrant resident activities. The proximity to South Hills Village Station makes commuting in and around Pittsburgh effortless, providing great connectivity for work and leisure travels. Step into a lifestyle of convenience and comfort at The Alden South Hills.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Alden South Hills Near South Hills Village",
      "seo_description": "Discover The Alden South Hills, ideally located close to South Hills Village Station, providing excellent connectivity and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166347",
      "source": "custom",
      "page_item_url": "memorial-hall-convenient-apartments-pittsburgh-alden-south-hills-628",
      "search_query": "memorial hall convenient apartments pittsburgh",
      "category": "Transit",
      "h1_title": "Convenient Apartments Near Memorial Hall",
      "h2_subtitle": "The Alden South Hills offers convenient apartments in Pittsburgh, close to Memorial Hall, blending accessibility with modern comforts.",
      "page_copy": "The Alden South Hills in Pittsburgh presents convenient apartment living near Memorial Hall, perfect for those who value both accessibility and modern comforts. Our community provides a range of floor plans from intimate studios to roomy three-bedroom apartments, each designed for contemporary living.\n\nLocated in Pleasant Hills, The Alden South Hills boasts amenities such as a fitness center, pet-friendly spaces, and a welcoming resident lounge, ideal for relaxation and socializing. The proximity to Memorial Hall offers residents easy access to various cultural and entertainment venues, making it an excellent choice for those who appreciate vibrant local living. Experience convenience and community at The Alden South Hills.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a large tree in front and manicured lawn.",
        "public_id": "01a015db-c3c2-706b-8e59-43c95d401ca8",
        "storage_key": "property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Apartments by Memorial Hall",
      "seo_description": "Live at The Alden South Hills, where convenient apartments meet Memorial Hall's vibrant Pittsburgh setting, offering ease and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5084"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976284730"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973437"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KPTVWR2P"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livethealdensouthhills.fatwin.com/api/websites/resources/1?x=NGxOYkhuTkZzWFdqaXh6UzNJL25oYnpwVUs5QUc3MWlQdXdPNElPTVhFL1JJMTRPQVNieU4yQ1NBQWNRVHJxbmxQeG5qMnRzYmsxeXUyS0JpcW1FV3c9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57765170234"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9547ceac-43e6-11ef-85e2-f31dfecfa23b"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547ceac-43e6-11ef-85e2-f31dfecfa23b/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547ceac-43e6-11ef-85e2-f31dfecfa23b/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlAxNi9STmVxRkVGMGovNmdLaStjWFE9PSIsInZhbHVlIjoiTzI4bnpjY250VHZxWGVScndrTlZSQT09IiwibWFjIjoiZTI3MmE0N2NhZDEyZDVjMGIxNjdkNmYzYTMwMDBmMTE1YTI4MDkzNGM3MzVjYWFkZTVkOTUzMzNkOWVmZjQzNSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5084",
  "custom_repli_id": "9976284730",
  "custom_realpage_id": "4973437",
  "custom_google_gtm_id": "GTM-KPTVWR2P",
  "custom_perq_script_url": "https://livethealdensouthhills.fatwin.com/api/websites/resources/1?x=NGxOYkhuTkZzWFdqaXh6UzNJL25oYnpwVUs5QUc3MWlQdXdPNElPTVhFL1JJMTRPQVNieU4yQ1NBQWNRVHJxbmxQeG5qMnRzYmsxeXUyS0JpcW1FV3c9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "57765170234",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9547ceac-43e6-11ef-85e2-f31dfecfa23b",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547ceac-43e6-11ef-85e2-f31dfecfa23b/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547ceac-43e6-11ef-85e2-f31dfecfa23b/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlAxNi9STmVxRkVGMGovNmdLaStjWFE9PSIsInZhbHVlIjoiTzI4bnpjY250VHZxWGVScndrTlZSQT09IiwibWFjIjoiZTI3MmE0N2NhZDEyZDVjMGIxNjdkNmYzYTMwMDBmMTE1YTI4MDkzNGM3MzVjYWFkZTVkOTUzMzNkOWVmZjQzNSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "3cac0f98-4db6-40c1-91f3-fd8251ab1789",
  "custom_audioeye_site_hash": "e26471e8918639b4906194c18b13f54f"
};

export const generatedAt = '2026-10-22T20:05:22.271Z';
